export default {
  translation: {
    // Added Showroom Replacements
    'showroom_unit_not_found': 'وحدة المعرض غير موجودة',
    'failed_load_showroom': 'فشل تحميل تفاصيل المعرض',
    'failed_delete_showroom': 'فشل حذف المعرض',
    'failed_update_status': 'فشل تحديث حالة المعرض',
    'loading_showroom_data': 'جاري تحميل بيانات المعرض…',
    'back_to_showrooms': 'العودة إلى المعارض',
    'showroom_not_found_title': 'المعرض غير موجود',
    'showroom_specifications': 'مواصفات المعرض',
    'confirm_delete_showroom_p1': 'هل أنت متأكد من حذف المعرض ',
    'confirm_delete_showroom_p2': '؟ لا يمكن التراجع عن هذا الإجراء.',
    'configure_showroom_park': 'تكوين مجمع المعارض',
    'register_new_showroom_park': 'تسجيل مجمع معارض جديد',
    'total_showrooms_label': 'إجمالي المعارض',
    'total_showrooms_desc': 'العدد الإجمالي لوحدات المعرض الفردية في المجمع.',
    'invalid_bulk_showroom_data': 'تنسيق بيانات غير صالح لإنشاء معارض مجمعة',
    'failed_create_bulk_showrooms': 'فشل إنشاء معارض مجمعة',
    'init_showrooms': 'تهيئة المعارض',
    'no_showrooms_in_complex': 'لم يتم العثور على وحدات معرض في هذا المجمع بعد.',
    'add_first_showroom': 'إضافة أول معرض',
    'add_showroom_btn': 'إضافة معرض',
    'no_showrooms_found_title': 'لم يتم العثور على معارض',
    'failed_load_showroom_data': 'فشل تحميل بيانات المعرض',
    'update_showroom_desc': 'قم بتحديث مواصفات وحدة المعرض هذه.',
    'register_showroom_desc': 'سجل وحدة معرض جديدة في المجمع.',
    'identity_and_location': 'الهوية والموقع',
    'complex_park_name': 'اسم المجمع / الحديقة',
    'physical_address': 'العنوان',
    'enter_full_geographic_address': 'أدخل العنوان الجغرافي الكامل',
    'used_for_mapping': 'يستخدم للخرائط وإنشاء التقارير الرسمية.',
    'capacity_and_zoning': 'السعة والتقسيم',
    'total_blocks_zones': 'إجمالي الكتل / المناطق',
    'how_many_blocks': 'كم عدد الكتل أو الصفوف المميزة التي يمتلكها هذا المجمع؟',
    'e_g_4': 'على سبيل المثال ٤',
    'e_g_100': 'على سبيل المثال ١٠٠',
    'e_g_northside': 'على سبيل المثال: مجمع الخدمات اللوجستية',
    'update_park': 'تحديث المجمع',
    'save_complex': 'حفظ المجمع',
    'location_and_identity': 'الموقع والهوية',
    'specifications': 'المواصفات',
    'available_count': '{{count}} متاح',
    'search_by_unit': 'البحث برقم الوحدة، المنطقة، النوع…',
    'all_types': 'جميع الأنواع',
    'no_showrooms_match': 'لا توجد معارض تطابق بحثك.',
    'search_showroom_units': 'بحث في وحدات المعرض، الملاك، المستأجرين...',
    'no_matching_showrooms_in_zone': 'لا توجد معارض مطابقة في المنطقة {{blockNum}}.',
    'search_showroom_placeholder': 'ابحث برقم الوحدة، المنطقة، النوع...',
    'no_showrooms_match_search': 'لا توجد معارض تطابق بحثك.',
    'clear_filters': 'مسح الفلاتر',
    'showroom_parks': 'مجمعات المعارض',
    'add_complex': 'إضافة مجمع',
    'bulk_add_showrooms': 'إضافة المعارض بالجملة',
    'avg_utilization': 'متوسط الاستخدام',
    'rented_sold_stat': 'مباع / مؤجر',
    'total_showrooms_stat': 'إجمالي المعارض',
    'total_complexes': 'إجمالي المجمعات',
    'preferred_language': 'اللغة المفضلة',
    'showroom_units': 'وحدات المعرض',



    // App
    'apartment_system': 'نظام إدارة المعارض',
    'apartment_management': 'إدارة المعارض',
    'building_management': 'إدارة المجمعات',

    // Navigation - updated
    'dashboard': 'لوحة التحكم',
    'user_management': 'إدارة المستخدمين',
    'building_management': 'إدارة المجمعات',
    'apartment_management': 'إدارة المعارض',
    'owner_management': 'إدارة الملاك',
    'tenant_management': 'إدارة المستأجرين',
    'payment_management': 'إدارة المدفوعات',
    'service_management': 'إدارة الخدمات',
    'report_management': 'التقارير والتحليلات',
    'log_management': 'سجلات النشاط',

    // Buildings
    'buildings': 'المجمعات',
    'building_list': 'قائمة المجمعات',
    'add_building': 'إضافة مجمع',
    'edit_building': 'تعديل المجمع',
    'building_details': 'تفاصيل المجمع',
    'building_name': 'اسم المجمع',
    'building_address': 'العنوان',
    'total_floors': 'إجمالي المستويات',
    'total_apartments': 'إجمالي وحدات المعرض',
    'building_view': 'عرض المجمع',
    'showing_all_apartments': 'عرض جميع وحدات المعرض',
    'expand_all_floors': 'عرض جميع المستويات',
    'collapse_all_floors': 'إخفاء جميع المستويات',
    'all_service_payments': 'جميع مدفوعات الخدمات',
    'manage_all_service_payments_across_buildings': 'إدارة جميع مدفوعات الخدمات عبر المجمعات',
    'tenants_management': 'إدارة المستأجرين',
    'manage_tenants_and_leases': 'إدارة المستأجرين والعقود',
    'past_tenants': 'المستأجرين السابقين',
    'lease_ended': 'انتهاء العقد',
    'end_lease_confirm_title': 'تأكيد انتهاء العقد',
    'end_lease_confirm_body': 'هل أنت متأكد من رغبتك في إنهاء هذا العقد؟',
    'no_past_tenants': 'لا يوجد مستأجرين سابقين',
    'status_expired_description': 'لقد انتهى هذا العقد. لا يمكن تطبيق أي مدفوعات أخرى عليه.',
    'lease_expired_warning': 'لقد انتهى هذا العقد.',
    'tenant_lease_expired_message': 'لا يمكن تطبيق أي مدفوعات أخرى عليه.',
    'expired_on': 'انتهى في',
    'manage_tenant': 'إدارة المستأجر',
    'move_in_pending': 'الانتقال قيد الانتظار',
    'lease_expired': 'انتهاء العقد',


    // Apartments (renamed from Properties)
    'apartments': 'وحدات المعرض',
    'apartment_list': 'قائمة وحدات المعرض',
    'add_apartment': 'إضافة وحدة معرض',
    'edit_apartment': 'تعديل وحدة المعرض',
    'apartment_details': 'تفاصيل وحدة المعرض',
    'apartment_number': 'رقم الوحدة',
    'apartment_display': 'غرفة {{number}}',
    'floor_number': 'رقم المستوى',
    'floor_display': 'المنطقة {{number}}',
    'zone_display': 'المنطقة {{number}}',
    'monthly_rent': 'الإيجار الشهري',
    'apartment_status': 'الحالة',
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'under_maintenance': 'تحت الصيانة',

    // Services
    'services': 'الخدمات',
    'service_payments': 'مدفوعات الخدمات',
    'generate_services': 'إنشاء مدفوعات الخدمات',
    'service_statistics': 'إحصائيات الخدمات',
    'service_type': 'نوع الخدمة',
    'service_amount': 'المبلغ',
    'service_date': 'تاريخ الخدمة',
    'service_status': 'حالة الدفع',
    'service_paid': 'مدفوع',
    'service_unpaid': 'غير مدفوع',

    // Showroom Registry specific
    'showroom_registry': 'سجل المعارض',
    'manage_showroom_units': 'إدارة ومتابعة {{count}} وحدات معرض في جميع المجمعات.',
    'add_first_showroom_to_start': 'أضف أول معرض لك للبدء.',
    'complex_park': 'مجمع / حديقة',
    'all_locations': 'جميع المواقع',
    'class_type': 'نوع الفئة',
    'all_classes': 'جميع الفئات',
    'utilities_active': 'الخدمات مفعلة',
    'all_systems': 'جميع الأنظمة',
    'yes_powered': 'نعم (كهرباء/تكييف)',
    'none': 'لا يوجد',
    'registry_error': 'خطأ في السجل',
    'retry_connection': 'إعادة المحاولة',
    'empty_registry': 'سجل فارغ',
    'no_showrooms_logged': 'لا توجد معارض مسجلة في النظام بعد.',
    'initialize_first_unit': 'إنشاء الوحدة الأولى',
    'no_matches_found': 'لم يتم العثور على نتائج',
    'adjust_parameters_to_locate': 'قم بتعديل المعلمات لتحديد مواقع المعارض.',
    'clear_parameters': 'مسح المعلمات',
    'unknown_complex': 'مجمع غير معروف',
    'n_a': 'غير متوفر',
    'toggle_status': 'تبديل الحالة',
    'manage': 'إدارة',
    'x_apartments_count': '{{count}} وحدات معرض',
    'x_apartment_single': 'وحدة معرض واحدة',
    'last_updated_today': '🗓 آخر تحديث: اليوم',
    'confirm_deletion_title': 'تأكيد الحذف',
    'confirm_deletion_desc': 'هل أنت متأكد أنك تريد حذف المعرض "{{device}}" نهائيًا؟ لا يمكن التراجع عن هذا الإجراء.',
    'auth_failed_login_again': 'فشلت المصادقة. يرجى تسجيل الدخول مرة أخرى.',
    'access_denied_admin_role': 'تم رفض الوصول. مطلوب دور المسؤول.',
    'server_error_backend_connection': 'خطأ في الخادم. يرجى التحقق من اتصال الخلفية.',
    'cannot_connect_to_server': 'تعذر الاتصال بالخادم. يرجى التحقق من شبكتك.',
    'failed_to_load_client_data': 'فشل تحميل بيانات العميل',
    'failed_to_load_showroom_data': 'فشل تحميل بيانات المعرض',

    // Reports - updated
    'revenue_report': 'تقرير الإيرادات',
    'payment_logs': 'سجلات المدفوعات',
    'occupancy_report': 'تقرير الإشغال',
    'monthly_payments_report': 'تقرير المدفوعات الشهرية',
    'monthly_payments_subtitle': 'عرض شامل لمدفوعات إيجار المستأجرين ودفعات الخدمات',
    'all_paid': 'جميعها مدفوعة',
    'try_adjusting_filters': 'جرب تعديل الشهر أو السنة أو الفلاتير',
    'pending': 'معلق',
    'total': 'المجموع',
    'print_receipt': 'طباعة إيصال',
    'monthly_revenue': 'الإيراد الشهري',
    'building_revenue': 'إيرادات المجمع',
    'owner_revenue': 'إيرادات المالك',
    'paid_until': 'مدفوع حتى',
    'tenant_payments': 'حالة مدفوعات المستأجر',
    'next_billing_date': 'تاريخ الفاتورة القادمة',
    'next_payment': 'الدفعة القادمة',
    'installment_schedule': 'جدول الأقساط',
    'current_tenant': 'المستأجر الحالي',
    'future_tenant_upcoming': 'المستأجر القادم',

    // Logs
    'activity_logs': 'سجلات النشاط',
    'tenant_logs': 'سجل المستأجرين',
    'revenue_by_user': 'الإيرادات حسب المستخدم',
    'active_properties': 'عقارات نشطة',
    'occupancy_rate_desc': '{{rate}}% معدل الإشغال',
    'vs_last_month': 'مقارنة بالشهر الماضي',
    'overdue_amount': '{{amount}} متأخرات',
    'payment_desc': 'دفع {{type}} - وحدة معرض {{number}}',
    'overdue_payments': 'مدفوعات متأخرة',
    'overdue_payments_msg': '{{count}} مستأجرين لديهم مدفوعات معلقة بإجمالي {{amount}}',
    'view_details': 'عرض التفاصيل',
    'lease_expiring_soon': 'عقد الإيجار ينتهي قريباً',
    'lease_expiring_msg': '{{count}} اتفاقيات إيجار تنتهي خلال 30 يوماً',
    'review_leases': 'مراجعة العقود',
    'trial_ending_soon': 'الفترة التجريبية تنتهي قريباً',
    'trial_ending_msg': 'تنتهي فترتك التجريبية خلال {{days}} أيام. يرجى الاشتراك لتجنب انقطاع الخدمة.',
    'upgrade_plan': 'ترقية الخطة',
    'last_7_days': 'آخر 7 أيام',
    'last_30_days': 'آخر 30 يوماً',
    'last_3_months': 'آخر 3 أشهر',
    'last_year': 'العام الماضي',
    'error_loading_dashboard': 'خطأ في تحميل لوحة القيادة',
    'reports_dashboard': 'لوحة تقارير الأداء',
    'overview_of_financial_performance': 'نظرة عامة على الأداء المالي وإحصائيات المجمعات',
    'view_all_reports': 'عرض جميع التقارير',
    'total_revenue': 'إجمالي الإيرادات',
    'total_payments_count': '{{count}} دفعة',
    'total_tenants': 'إجمالي المستأجرين',
    'new_tenants_this_year': '{{count}} مستأجر جديد هذا العام',
    'total_buildings_count': '{{count}} مجمع',
    'total_owners': 'الملاك المقيمون ',
    'urgent_action': 'إجراء عاجل',
    'ended_contracts_count': '{{count}} عقد منتهي',
    'monthly_revenue_year': 'الإيرادات الشهرية - {{year}}',
    'occupancy_rate': 'معدل الإشغال',
    'quick_reports': 'تقارير سريعة',
    'annual_revenue': 'الإيرادات السنوية',
    'yearly_breakdown': 'تفصيل سنوي لجميع الإيرادات',
    'building_revenue': 'إيرادات المجمعات',
    'revenue_by_building': 'تفصيل الإيرادات حسب المجمع',
    'owner_revenue': 'إيرادات الملاك',
    'revenue_by_owner': 'تفصيل الإيرادات حسب مالك العقار',
    'detailed_payment_history': 'سجل مدفوعات مفصل وسجلات',
    'occupied': 'مشغول',
    'vacant': 'شاغر',
    'maintenance': 'صيانة',
    'excellent': 'ممتاز',
    'good': 'جيد',
    'needs_improvement': 'بحاجة لتحسين',
    'rent': 'إيجار',
    'service': 'خدمة',
    'deposit': 'تأمين',
    'commission': 'عمولة',
    'insurance': 'تأمين',
    'total': 'الإجمالي',
    'no_recent_payments': 'لا توجد مدفوعات حديثة',
    'no_overdue_payments': 'لا توجد مدفوعات متأخرة',
    'overdue': 'متأخر',
    'partial': 'جزئي',
    'expired': 'منتهي',
    'pending': 'قيد الانتظار',
    'paid': 'مدفوع',
    'apt': 'وحدة معرض',
    'days_overdue': 'أيام تأخير',
    'more_overdue_tenants': 'مستأجرين آخرين متأخرين',
    'error_fetching_occupancy': 'خطأ في جلب بيانات الإشغال',
    'failed_load_occupancy': 'فشل في تحميل إحصائيات الإشغال',
    'error_fetching_payments': 'خطأ في جلب المدفوعات الحديثة',
    'failed_load_payments': 'فشل في تحميل المدفوعات الحديثة',
    'error_fetching_tenant_status': 'خطأ في جلب حالة دفع المستأجر',
    'failed_load_tenant_status': 'فشل في تحميل حالة دفع المستأجر',
    'failed_to_load_report_data': 'فشل في تحميل بيانات التقرير',
    'recent_transactions': 'المعاملات الحديثة',
    'alerts_notifications': 'التنبيهات والإشعارات',
    'create_hold': 'إنشاء حجز',
    'billing_subscription': 'الفواتير والاشتراك',
    'current_plan': 'الخطة الحالية',
    'subscribe_now': 'اشترك الآن',
    'manage_your_subscription_and_billing': 'إدارة اشتراكك وفواتيرك',
    'view_payment_logs': 'عرض سجلات المدفوعات',
    'view_activity_logs': 'عرض سجلات النشاط',
    'view_revenue_report': 'عرض تقرير الإيرادات',
    'view_occupancy_report': 'عرض تقرير الإشغال',
    'view_tenant_logs': 'عرض سجلات المستأجرين',
    'login_success': 'تم تسجيل الدخول بنجاح',
    'logout_success': 'تم تسجيل الخروج بنجاح',
    'record_payment': 'تسجيل دفعة',
    'occupied_status': 'مشغول',


    "floor_number": "المستوى {{number}}",
    "apartment_number": "غرفة {{number}}",


    // Common
    'loading': 'جاري التحميل...',
    'save': 'حفظ',
    'cancel': 'إلغاء',
    'edit': 'تعديل',
    'delete': 'حذف',
    'add': 'إضافة',
    'view': 'عرض',
    'search': 'بحث',
    'filter': 'تصفية',
    'actions': 'الإجراءات',
    'status': 'الحالة',
    'active': 'نشط',
    'inactive': 'غير نشط',
    'yes': 'نعم',
    'no': 'لا',
    'confirm': 'تأكيد',
    'success': 'نجح',
    'error': 'خطأ',
    'warning': 'تحذير',
    'info': 'معلومات',

    // App
    'apartment_system': 'نظام وحدات المعرض',
    'apartment_management': 'إدارة المعارض',

    // Authentication
    'login': 'تسجيل الدخول',
    'logout': 'تسجيل الخروج',
    'username': 'اسم المستخدم',
    'password': 'كلمة المرور',
    'email': 'البريد الإلكتروني',
    'remember_me': 'تذكرني',
    'forgot_password': 'نسيت كلمة المرور؟',
    'login_failed': 'فشل تسجيل الدخول',
    'invalid_credentials': 'بيانات غير صحيحة',

    // Navigation
    'dashboard': 'لوحة القيادة',
    'core': 'الأساسي',
    'user_management': 'إدارة المستخدمين',
    'property_management': 'إدارة المجمعات',
    'financial_management': 'الإدارة المالية',
    'reports_analytics': 'التقارير والتحليلات',
    'logs_audit': 'السجلات والتدقيق',
    'all_activities': 'جميع الأنشطة',
    'tenant_activities': 'أنشطة المستأجرين',
    'system': 'النظام',
    'bookings': 'الحجوزات',
    'booking_list': 'قائمة الحجوزات',
    'new_booking': 'حجز جديد',
    'booking_calendar': 'تقويم الحجوزات',
    'waitlist': 'قائمة الانتظار',
    'analytics': 'التحليلات',
    'subscription': 'الاشتراك',
    'whatsapp': 'واتساب',
    'manage_services': 'إدارة الخدمات',
    'generate_payments': 'إنشاء المدفوعات',
    'reports_dashboard': 'لوحة التقارير',

    // Users
    'system_users': 'مستخدمي النظام',
    'user_list': 'قائمة المستخدمين',
    'add_user': 'إضافة مستخدم',
    'edit_user': 'تعديل المستخدم',
    'user_profile': 'ملف المستخدم',
    'first_name': 'الاسم الأول',
    'last_name': 'اسم العائلة',
    'phone_number': 'رقم الهاتف',
    'role': 'الدور',
    'administrator': 'المدير',
    'front_desk': 'الاستقبال',
    'accountant': 'محاسب',
    'sales_role': 'مبيعات',
    'created_at': 'تاريخ الإنشاء',
    'last_login': 'آخر تسجيل دخول',
    'never': 'أبداً',

    // Properties
    'properties': 'المجمعات',
    'property_list': 'قائمة المجمعات',
    'add_property': 'إضافة عقار',
    'property_owners': 'ملاك المجمعات',
    'owner_list': 'قائمة الملاك',
    'add_owner': 'إضافة مالك',
    'owners': 'الملاك',

    // Tenants
    'tenants': 'المستأجرين',
    'tenant_list': 'قائمة المستأجرين',
    'add_tenant': 'إضافة مستأجر',
    'owner_living': 'سكن المالك',
    'future_tenant': 'مستأجر مستقبلي',
    'overdue_rent': 'الإيجارات المتأخرة',

    // Tenant Detail & Lifecycle
    'search_tenants_placeholder': 'البحث عن مستأجر حسب الاسم أو الهاتف أو وحدة المعرض',
    'terminate_contract': 'إنهاء العقد',
    'terminate_confirmation_desc': 'هل أنت متأكد من رغبتك في إنهاء عقد الخدمات اللوجستية النشط لهذا العميل؟ سيؤدي هذا الإجراء إلى إخلاء الوحدة فوراً.',
    'terminating': 'جاري الإنهاء...',
    'terminate': 'إنهاء',
    'loading_client_profile': 'جاري تحميل ملف العميل...',
    'profile_error': 'خطأ في الملف الشخصي',
    'client_not_found': 'لم يتم العثور على كيان العميل.',
    'back_to_roster': 'العودة إلى القائمة',
    'contract_ended': 'انتهى العقد',
    'unit_number_display': 'وحدة {{number}}',
    'block_number_display': '(كتلة {{number}})',
    'contract_information': 'معلومات العقد',
    'extend': 'تمديد',
    'relocate': 'نقل',
    'renew_contract': 'تجديد العقد',
    'configure': 'تكوين',
    'renter': 'مستأجر',
    'renters': 'المستأجرين',
    'showroom_unit': 'وحدة العرض',
    'complex': 'مجمع الخدمات اللوجستية',
    'active_unit': 'الوحدة النشطة',
    'status_override': 'تجاوز الحالة',
    'force_status_change': 'تغيير الحالة إجبارياً',
    'complex_zoning': 'المجمع والتقسیم',
    'block_zone': 'الكتلة / المنطقة',
    'showroom_specifications': 'مواصفات المعرض',
    'class_type': 'فئة النوع',
    'internal_size': 'المساحة الداخلية',
    'utilities_active': 'الخدمات النشطة',
    'owner_investor_details': 'تفاصيل المالك / المستثمر',
    'entity_name': 'اسم الكيان',
    'contact_number': 'رقم التواصل',
    'future_client_upcoming': 'عميل مستقبلي (قادم)',
    'active_client': 'عميل نشط',
    'contract_specs': 'مواصفات العقد',
    'net_effective': 'صافي السعر الفعلي',
    'system_timestamps': 'الطوابع الزمنية للنظام',
    'queue_holds': 'قائمة الانتظار والحجوزات',
    'historical_ledger': 'السجل التاريخي',
    'historical_ledger_desc': 'عقود العملاء السابقين المرتبطة بهذه الوحدة.',
    'final_balance': 'الرصيد النهائي',
    'archive': 'الأرشيف',
    'notice': 'تنبيه',
    'try_again': 'حاول مرة أخرى',
    'back': 'رجوع',
    'showroom_not_found_desc': 'الوحدة التي تبحث عنها غير موجودة أو تم حذفها.',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_unit': 'حذف الوحدة',
    'unknown_complex': 'مجمع غير معروف',
    'rented_sold': 'مؤجر / مباع',
    'contract_expired': 'العقد منتهي',
    'yes_pwr_clim': 'نعم (كهرباء/تكييف)',
    'none': 'لا يوجد',
    'view_client_profile': 'عرض ملف العميل',
    'acct_status': 'حالة الحساب',
    'logged_on': 'تم التسجيل في',
    'last_modification': 'آخر تعديل',
    'log_new_hold': 'تسجيل حجز جديد',
    'view_full_queue': 'عرض قائمة الانتظار الكاملة',
    'log_new_client': 'تسجيل عميل جديد',
    'access_client_data': 'الوصول إلى بيانات العميل',
    'clear_maintenance': 'إنهاء الصيانة',
    'return_to_complex': 'العودة إلى المجمع',
    'configure_unit': 'تكوين الوحدة',
    'critical_contract_expired': 'هام: العقد منتهي',
    'resolve_contract': 'تسوية العقد',
    'entity': 'الكيان',
    'contract_period': 'فترة العقد',
    'payment_type_commission': 'عمولة',
    'day': 'يوم',
    'lapsed_on': 'انتهى في',
    'secured_by_client': 'مؤمن حالياً من قبل عميل.',
    'available_for_logging': 'شاغرة ومتاحة للتسجيل.',
    'locked_for_maintenance': 'الوحدة مغلقة للصيانة.',
    'no_active_queue': 'لا توجد قائمة انتظار أو حجوزات نشطة لهذه الوحدة.',
    'contract_lapsed_desc': 'عقد الخدمات اللوجستية لـ {{name}} قد انتهى ويتطلب تجديداً أو إنهاءً فورياً.',
    'revenue_breakdown_desc': 'عرض تفاصيل الإيرادات حسب المستخدم لشهر معين',
    'indefinite': 'غير محدد',
    'contract_exceeded_desc': 'تجاوز العقد تاريخ الانتهاء.',
    'command_center': 'مركز التحكم',
    'no_historical_records': 'لم يتم العثور على سجلات تاريخية.',
    'no_phone': 'لا يوجد هاتف',
    'view': 'عرض',
    'base_rate': 'السعر الأساسي',
    'billing_cycle': 'دورة الفوترة',
    'ledger_debt': 'ديون السجل',
    'clear_until': 'خالص حتى',
    'not_set': 'غير محدد',
    'entity_profile': 'ملف الكيان',
    'active_contracts': 'العقود النشطة',
    'financial_ledger': 'السجل المالي',
    'entity_contacts': 'جهات اتصال الكيان',
    'email_address': 'البريد الإلكتروني',
    'primary_phone': 'الهاتف الأساسي',
    'comm_language': 'لغة التواصل',
    'base_contract_details': 'تفاصيل العقد الأساسية',
    'valid_window': 'فترة الصلاحية',
    'unknown_period': 'فترة غير معروفة',
    'invalid_format': 'تنسيق غير صالح',
    'invalid_data': 'بيانات غير صالحة',
    'contract_extended_success': 'تم تمديد العقد بنجاح',
    'contract_renewed_success': 'تم تجديد العقد بنجاح',
    'relocated_success': 'تم نقل العميل بنجاح',
    'months': 'أشهر',
    'term_months': '{{count}} أشهر',
    'please_enter_valid_payment_amount': 'يرجى إدخال مبلغ دفع صالح',
    'end_date_must_be_after_start_date': 'يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء',
    'failed_to_add_payment': 'فشل في إضافة الدفعة',
    'failed_to_terminate_contract': 'فشل في إنهاء العقد',
    'failed_to_relocate_client': 'فشل في نقل العميل',
    'to': 'إلى',
    'gross_rate': 'المعدل الإجمالي',
    'applied_discount': 'الخصم المطبق',
    'net_effective_rate': 'صافي المعدل الفعلي',
    'surcharges_deposits': 'الرسوم الإضافية والتأمينات',
    'service_fee': 'رسوم الخدمة',
    'commission': 'العمولة',
    'sec_deposit': 'تأمين الضمان',
    'entity_notes': 'ملاحظات الكيان',
    'contract_registry': 'سجل العقود',
    'logs_count': '({{count}} سجلات)',
    'no_contracts_found': 'لم يتم العثور على عقود',
    'no_contracts_desc': 'هذا الكيان ليس له عقود نشطة أو تاريخية مرفقة.',
    'historical_contracts': 'العقود التاريخية',
    'ended': 'منتهي',
    'valid_from': 'صالح من',
    'valid_to': 'صالح إلى',
    'total_term': 'إجمالي المدة',
    'remaining': 'المتبقي',
    'total_value': 'القيمة الإجمالية',
    'log_payment': 'تسجيل الدفع',
    'months': 'شهور',
    'n_a': 'غير متوفر',
    'page': 'صفحة',
    'showing_items': 'عرض {{start}}-{{end}} من {{total}}',
    'first_page': 'الصفحة الأولى',
    'previous_page': 'الصفحة السابقة',
    'next_page': 'الصفحة التالية',
    'last_page': 'الصفحة الأخيرة',
    'showing_filtered_results': 'عرض {{showing}} من إجمالي {{total}}',
    'transaction_amount': 'مبلغ المعاملة',
    'type': 'النوع',
    'log_date': 'تاريخ التسجيل',
    'covered_period': 'الفترة المغطاة',
    'ref_notes': 'المرجع/ملاحظات',
    'no_transactions_found': 'لم يتم العثور على معاملات',
    'no_transactions_desc': 'السجل المالي لهذا الكيان فارغ حالياً.',
    'log_transaction': 'تسجيل معاملة',
    'initialize_ledger': 'تهيئة السجل',
    'processing_ledger': 'جاري معالجة السجل...',
    'rent': 'إيجار',
    'unknown_status': 'حالة غير معروفة',
    'cancel': 'إلغاء',
    'renew_logistics_contract': 'تجديد عقد الخدمات اللوجستية',
    'allocated_unit': 'الوحدة المخصصة',
    'select_target_unit': 'اختر الوحدة المستهدفة...',
    'current_unit': 'الوحدة الحالية',
    'new_base_rate': 'السعر الأساسي الجديد',
    'billing_cycle_start': 'بدء دورة الفوترة',
    'finalize_renewal': 'إتمام التجديد',
    'relocate_client_unit': 'نقل وحدة العميل',
    'current_allocation': 'التخصيص الحالي',
    'select_target_slot': 'اختر الفتحة المستهدفة...',
    'confirm_relocation': 'تأكيد النقل',
    'processing': 'جاري المعالجة...',
    'extend_contract': 'تمديد العقد',
    'current_end_date': 'تاريخ الانتهاء الحالي',
    'new_end_date': 'تاريخ الانتهاء الجديد',
    'confirm_extension': 'تأكيد التمديد',
    'finalize_transaction': 'إرسال السجل',
    'extending_contract': 'جاري تمديد العقد...',
    'terminated': 'منتهي',
    'from': 'من',
    'expiring_soon_label': 'ينتهي قريباً',
    'preferred_language': 'اللغة المفضلة',
    'english': 'الإنجليزية',
    'arabic': 'العربية',
    'kurdish': 'الكردية',
    'tenant_notes_placeholder': 'أدخل ملاحظات لهذا المستأجر...',




    // Payments
    'payments': 'المدفوعات',
    'all_payments': 'جميع المدفوعات',
    'record_payment': 'تسجيل دفعة',
    'overdue_payments': 'المدفوعات المتأخرة',
    'receipts': 'الإيصالات',

    // Reports
    'reports': 'التقارير',
    'all_reports': 'جميع التقارير',
    'financial_reports': 'التقارير المالية',
    'payment_reports': 'تقارير المدفوعات',
    'property_reports': 'تقارير المجمعات',

    // Settings
    'settings': 'الإعدادات',
    'profile_settings': 'إعدادات الملف الشخصي',
    'system_settings': 'إعدادات النظام',
    'profile': 'الملف الشخصي',
    'personal_details': 'التفاصيل الشخصية',
    'security_settings': 'إعدادات الأمان',
    'change_password': 'تغيير كلمة المرور',
    'current_password': 'كلمة المرور الحالية',
    'new_password': 'كلمة المرور الجديدة',
    'confirm_new_password': 'تأكيد كلمة المرور الجديدة',
    'organization_settings': 'إعدادات المؤسسة',
    'organization_name': 'اسم المؤسسة',
    'timezone': 'المنطقة الزمنية',
    'subscription_plan': 'خطة الاشتراك',
    'standard_plan': 'الخطة القياسية',
    'enterprise_plan': 'خطة المؤسسات',
    'trial_period': 'فترة تجريبية',
    'days_left': 'متبقي {{days}} يوم',
    'update_profile_success': 'تم تحديث الملف الشخصي بنجاح',
    'update_password_success': 'تم تغيير كلمة المرور بنجاح',
    'update_system_success': 'تم تحديث إعدادات النظام بنجاح',

    // Notifications
    'notifications': 'الإشعارات',
    'view_all_notifications': 'عرض جميع الإشعارات',

    // WhatsApp Settings
    'whatsapp_settings': 'إعدادات الواتساب',
    'whatsapp_settings_description': 'إشعارات الواتساب المؤتمتة للمستأجرين والمالكين',
    'send_reminders_now': 'إرسال التذكيرات الآن',
    'general_settings': 'الإعدادات العامة',
    'whatsapp_enable': 'تفعيل إشعارات الواتساب',
    'whatsapp_enable_sub': 'تشغيل أو إيقاف جميع رسائل الواتساب المؤتمتة',
    'default_country_code': 'رمز الدولة الافتراضي',
    'default_messaging_language': 'لغة الرسائل الافتراضية',
    'default_language_help': 'تستخدم إذا لم يكن لدى المستأجر لغة مفضلة محددة.',
    'tenant_rent_reminder': 'تذكير إيجار المستأجر',
    'enable_tenant_rent_reminders': 'تفعيل التذكيرات',
    'tenant_rent_reminder_sub': 'إرسال تذكير للمستأجرين قبل أو بعد تاريخ استحقاق الدفع',
    'days_before_due': 'الأيام قبل الاستحقاق',
    'service_fee_reminder': 'تذكير رسوم الخدمة',
    'enable_service_fee_reminder': 'تفعيل تذكير رسوم الخدمة',
    'service_fee_reminder_sub': 'إخطار المستأجرين بمدفوعات رسوم الخدمة القادمة',
    'owner_reminder': 'تذكير المالك',
    'enable_owner_reminders': 'تفعيل تذكيرات المالك',
    'owner_reminder_sub': 'إخطار المالكين عندما يكون لدى مستأجريهم مدفوعات متأخرة',
    'payment_confirmation': 'تأكيد الدفع',
    'send_on_payment': 'إرسال عند الدفع',
    'payment_confirmation_sub': 'يتم إرسالها تلقائياً للمستأجر عند تسجيل الدفعة',
    'preview_reminders': 'معاينة التذكيرات المؤتمتة',
    'failed_to_load_settings': 'فشل تحميل الإعدادات',
    'settings_saved': 'تم حفظ الإعدادات بنجاح',
    'failed_to_save': 'فشل الحفظ',
    'server_error': 'خطأ في الخادم',

    // Forms
    'personal_information': 'المعلومات الشخصية',
    'account_information': 'معلومات الحساب',
    'security': 'الأمان',
    'enter_first_name': 'أدخل الاسم الأول',
    'enter_last_name': 'أدخل اسم العائلة',
    'enter_email': 'أدخل البريد الإلكتروني',
    'enter_username': 'أدخل اسم المستخدم',
    'enter_password': 'أدخل كلمة المرور',
    'enter_phone_number': 'أدخل رقم الهاتف',
    'confirm_password': 'تأكيد كلمة المرور',
    'leave_blank_to_keep_current': 'اتركه فارغاً للاحتفاظ بكلمة المرور الحالية',

    // Validation
    'first_name_required': 'الاسم الأول مطلوب',
    'last_name_required': 'اسم العائلة مطلوب',
    'email_required': 'البريد الإلكتروني مطلوب',
    'invalid_email': 'يرجى إدخال بريد إلكتروني صحيح',
    'username_required': 'اسم المستخدم مطلوب',
    'username_too_short': 'اسم المستخدم يجب أن يكون 3 أحرف على الأقل',
    'password_required': 'كلمة المرور مطلوبة',
    'password_too_short': 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    'passwords_do_not_match': 'كلمات المرور غير متمستوىة',
    'phone_invalid_format': 'يرجى إدخال رقم هاتف صحيح',

    // Actions
    'saving': 'جاري الحفظ...',
    'deleting': 'جاري الحذف...',
    'loading_users': 'جاري تحميل المستخدمين...',
    'loading_user_data': 'جاري تحميل بيانات المستخدم...',
    'update': 'تحديث',
    'activate': 'تفعيل',
    'deactivate': 'إلغاء تفعيل',
    'show_all': 'عرض الكل',
    'hide_inactive': 'إخفاء غير النشط',
    'all_roles': 'جميع الأدوار',
    'retry': 'إعادة المحاولة',

    // Messages
    'no_users_found': 'لا يوجد مستخدمين',
    'user_created_successfully': 'تم إنشاء المستخدم بنجاح',
    'user_updated_successfully': 'تم تحديث المستخدم بنجاح',
    'user_deleted_successfully': 'تم حذف المستخدم بنجاح',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_user_confirmation': 'هل أنت متأكد من حذف {{name}}؟ لا يمكن التراجع عن هذا الإجراء.',

    // Dashboard
    'welcome_back': 'مرحباً بعودتك',
    'dashboard_subtitle': 'إليك ما يحدث مع عقاراتك اليوم.',
    'total_properties': 'إجمالي المجمعات',
    'active_tenants': 'المستأجرين النشطين',
    'monthly_revenue': 'الإيرادات الشهرية',
    'pending_payments': 'المدفوعات المعلقة',
    'recent_activity': 'النشاط الأخير',
    'quick_actions': 'الإجراءات السريعة',
    'showing': 'عرض',
    'of': 'من',
    'users': 'مستخدمين',
    'contact': 'جهة الاتصال',
    'user': 'المستخدم',

    // Sidebar specific translations
    'core': 'الأساسي',
    'user_management': 'إدارة المستخدمين',
    'property_management': 'إدارة المجمعات',
    'financial_management': 'الإدارة المالية',
    'reports_analytics': 'التقارير والتحليلات',
    'logs_audit': 'السجلات والتدقيق',
    'system': 'النظام',

    'system_users': 'مستخدمي النظام',
    'user_list': 'قائمة المستخدمين',
    'add_user': 'إضافة مستخدم',

    'buildings': 'المجمعات',
    'building_list': 'قائمة المجمعات',
    'add_building': 'إضافة مجمع',

    'apartments': 'وحدات المعرض',
    'apartment_list': 'قائمة وحدات المعرض',
    'add_apartment': 'إضافة وحدة معرض',

    'owners': 'الملاك',
    'owner_list': 'قائمة الملاك',
    'add_owner': 'إضافة مالك',

    'tenants': 'المستأجرين',
    'tenant_list': 'قائمة المستأجرين',
    'add_tenant': 'إضافة مستأجر',
    'overdue_rent': 'إيجار متأخر',

    'payments': 'المدفوعات',
    'all_payments': 'جميع المدفوعات',
    'record_payment': 'تسجيل دفعة',
    'payment_stats': 'إحصائيات الدفع',

    'service_payments': 'مدفوعات الخدمات',
    'manage_services': 'إدارة الخدمات',
    'generate_payments': 'إنشاء مدفوعات',
    'service_statistics': 'إحصائيات الخدمات',

    'reports': 'التقارير',
    'reports_dashboard': 'لوحة التقارير',
    'revenue_report': 'تقرير الإيرادات',
    'payment_logs': 'سجلات الدفع',
    'occupancy_report': 'تقرير الإشغال',
    'tenant_payments': 'مدفوعات المستأجرين',
    'building_revenue': 'إيرادات المجمع',
    'owner_revenue': 'إيرادات المالك',

    'activity_logs': 'سجلات النشاط',
    'all_activities': 'كل الأنشطة',
    'tenant_activities': 'أنشطة المستأجرين',
    'monthly_revenue': 'الإيراد الشهري',

    'settings': 'الإعدادات',
    'profile_settings': 'إعدادات الملف الشخصي',
    'system_settings': 'إعدادات النظام',

    'logout': 'تسجيل الخروج',

    // Apartment Detail View
    'loading_apartment_details': 'جاري تحميل تفاصيل وحدة المعرض...',
    'error_loading_apartment': 'خطأ في تحميل تفاصيل وحدة المعرض',
    'try_again': 'حاول مرة أخرى',
    'back_to_apartments': 'العودة إلى وحدات المعرض',
    'apartment_not_found': 'وحدة المعرض غير موجودة',
    'apartment_not_found_message': 'وحدة المعرض التي تبحث عنها غير موجودة أو تم حذفها.',

    'building_and_location': 'المجمع والموقع',
    'building': 'المجمع',
    'floor': 'المستوى',
    'address': 'العنوان',

    'apartment_details': 'تفاصيل وحدة المعرض',
    'apartment_type': 'النوع',
    'size': 'المساحة',
    'furnished': 'مجهزة بمرافق',

    'owner_information': 'معلومات المالك',
    'owner_name': 'الاسم',
    'owner_contact': 'الاتصال',

    'additional_information': 'معلومات إضافية',
    'created_at': 'تاريخ الإنشاء',
    'updated_at': 'آخر تحديث',

    'status_management': 'إدارة الحالة',
    'status_vacant': 'شاغرة',
    'status_occupied': 'مشغولة',
    'status_maintenance': 'تحت الصيانة',
    'status_vacant_description': 'متاحة للإيجار أو التأجير',
    'status_occupied_description': 'مؤجرة حالياً لمستأجر',
    'status_maintenance_description': 'تحت الصيانة أو التجديد',
    'change_status': 'تغيير الحالة إلى',

    'quick_actions': 'إجراءات سريعة',
    'create_lease': 'إنشاء عقد إيجار',
    'view_tenant_info': 'عرض معلومات المستأجر',
    'mark_maintenance_complete': 'تعليم الصيانة كمكتملة',
    'view_building': 'عرض المجمع',
    'edit_apartment': 'تعديل وحدة المعرض',

    'same_building_apartments': 'نفس المجمع',
    'view_all_apartments_in_building': 'عرض جميع وحدات المعرض في المجمع',
    'view_vacant_apartments': 'عرض وحدات المعرض الشاغرة',

    // Delete confirmation
    'delete_apartment_confirmation': 'هل أنت متأكد من حذف وحدة المعرض "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',


    // Apartment Form
    'loading_apartment_data': 'جاري تحميل بيانات وحدة المعرض...',
    'edit_apartment': 'تعديل وحدة المعرض',
    'add_new_apartment': 'إضافة وحدة معرض جديدة',

    'basic_information': 'المعلومات الأساسية',
    'apartment_number': 'رقم الوحدة',
    'enter_apartment_number': 'أدخل رقم وحدة المعرض',
    'floor_number': 'رقم المستوى',
    'enter_floor_number': 'أدخل رقم المستوى',
    'size_sqm': 'المساحة (م²)',
    'enter_size': 'أدخل المساحة بالمتر المربع',
    'apartment_type': 'نوع الوحدة',
    'select_apartment_type': 'اختر نوع وحدة المعرض',
    'select_building': 'اختر المجمع',
    'furnished': 'مجهزة بمرافق',

    // Validation messages
    'floor_required': 'الصف/القسم مطلوب',
    'row_section': 'الصف / القسم',
    'enter_row_section': 'أدخل رقم الصف أو القسم',
    'apartment_number_required': 'رقم وحدة المعرض مطلوب',
    'size_required': 'المساحة مطلوبة',
    'type_required': 'نوع وحدة المعرض مطلوب',
    'building_required': 'المجمع مطلوب',
    'invalid_size': 'يجب أن تكون المساحة أكبر من الصفر',

    // Form actions
    'update': 'تحديث',
    'save': 'حفظ',
    'saving': 'جاري الحفظ...',


    // Apartment List
    'apartments': 'وحدات المعرض',
    'search_apartments': 'ابحث عن وحدات معرض...',
    'filter': 'تصفية',
    'grid_view': 'شبكة',
    'list_view': 'قائمة',
    'add_apartment': 'إضافة وحدة معرض',
    'all_buildings': 'جميع المجمعات',
    'all_types': 'جميع الأنواع',
    'all_statuses': 'جميع الحالات',
    'all': 'الكل',
    'vacant_apartments': 'وحدات معرض شاغرة',
    'occupied_apartments': 'وحدات معرض مشغولة',
    'maintenance_apartments': 'تحت الصيانة',
    'loading_apartments': 'جاري تحميل وحدات المعرض...',
    'error_loading_apartments': 'خطأ في تحميل وحدات المعرض',
    'no_apartments_found': 'لا توجد وحدات معرض',
    'no_apartments_message': 'لا توجد وحدات معرض في النظام حتى الآن.',
    'create_first_apartment': 'إنشاء أول وحدة معرض',
    'showing_filtered_results': 'عرض {{showing}} من أصل {{total}} وحدة معرض',

    // Statuses
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'maintenance': 'تحت الصيانة',

    // Apartment card
    'furnished': 'مجهزة بمرافق',

    // Delete confirmation
    'delete_apartment_confirmation': 'هل أنت متأكد من حذف وحدة المعرض "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'deleting': 'جاري الحذف...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'إنشاء وحدات معرض بالجملة',
    'preview': 'معاينة',
    'apartment_number_format': 'تنسيق رقم وحدة المعرض',
    'format_pattern': 'نمط التنسيق',
    'format_pattern_help': 'استخدم {floor} لرقم المستوى و {unit} لرقم الوحدة. مثال: {floor}{unit} = 0201',
    'preview_example': 'مثال المعاينة',
    'floor_plans': 'خطط المستويات',
    'add_floor_plan': 'إضافة خطة مستوى',
    'floor_plan_number': 'خطة المستوى {number}',
    'floors_comma_separated': 'المستويات (مفصولة بفواصل)',
    'unit_types': 'أنواع الوحدات',
    'add_unit_type': 'إضافة نوع وحدة',
    'unit_type_number': 'نوع الوحدة {number}',
    'name': 'الاسم',
    'quantity': 'الكمية',
    'type': 'النوع',
    'area_sqm': 'المساحة (م²)',
    'furnished': 'مجهزة بمرافق',
    'apartment_preview_count': 'معاينة وحدات المعرض ({count} وحدة)',
    'floor_unit_type': 'مستوى {floor} • {type}',
    'close': 'إغلاق',
    'create_apartments': 'إنشاء وحدات معرض',
    'create_apartments_count': 'إنشاء {count} وحدة معرض',
    'creating_apartments': 'جاري إنشاء وحدات المعرض...',
    'add_at_least_one_floor_plan': 'الرجاء إضافة خطة مستوى واحدة على الأقل',
    'no_apartments_to_create': 'لا توجد وحدات معرض لإنشائها',


    'building_name_required': 'اسم المجمع مطلوب',
    'building_address_required': 'عنوان المجمع مطلوب',
    'invalid_floors': 'يجب أن يكون عدد المستويات 1 على الأقل',
    'invalid_apartments': 'يجب أن يكون عدد وحدات المعرض 0 على الأقل',
    'loading_building_data': 'جاري تحميل بيانات المجمع...',
    'edit_building': 'تعديل المجمع',
    'add_new_building': 'إضافة مجمع جديد',
    'basic_information': 'المعلومات الأساسية',
    'building_name': 'اسم المجمع',
    'enter_building_name': 'أدخل اسم المجمع',
    'total_floors': 'إجمالي المستويات',
    'number_of_floors': 'عدد المستويات',
    'total_apartments': 'إجمالي وحدات المعرض',
    'number_of_apartments': 'عدد وحدات المعرض',
    'address': 'العنوان',
    'enter_complete_building_address': 'أدخل عنوان المجمع الكامل',
    'cancel': 'إلغاء',
    'saving': 'جاري الحفظ...',
    'update': 'تحديث',
    'save': 'حفظ',


    'buildings': 'المجمعات',
    'search_buildings': 'ابحث عن المجمعات...',
    'bulk_add_apartments': 'إضافة وحدات معرض بالجملة',
    'bulk_add': 'إضافة مجمعية',
    'total_buildings': 'إجمالي المجمعات',
    'avg_occupancy': 'متوسط الإشغال',
    'add_building': 'إضافة مجمع',
    'loading_buildings': 'جاري تحميل المجمعات...',
    'error_loading_buildings': 'خطأ في تحميل المجمعات',
    'try_again': 'حاول مرة أخرى',
    'no_buildings_found': 'لم يتم العثور على مجمعات',
    'no_buildings_yet': 'لا توجد مجمعات بعد',
    'no_buildings_match_search': 'لا توجد مجمعات تمستوى "{{search}}"',
    'no_buildings_message': 'لا توجد مجمعات في النظام حتى الآن. أضف مجمع أول لتبدأ.',
    'create_first_building': 'إنشاء أول مجمع',
    'showing_filtered_results': 'عرض {{showing}} من أصل {{total}} مجمع',
    'floors': 'مستويات',
    'levels': 'مستويات',
    'no_inventory_data': 'لا توجد وحدات بعد',
    'init_units': 'إضافة وحدات',
    'apartments': 'وحدات معرض',
    'occupancy': 'الإشغال',
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'no_apartments_yet': 'لا توجد وحدات معرض بعد',
    'add_apartments': '+ إضافة وحدات معرض',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_building_confirmation': 'هل أنت متأكد أنك تريد حذف المجمع "{{name}}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'cancel': 'إلغاء',
    'deleting': 'جاري الحذف...',
    'delete': 'حذف',
    'create_building_first': 'الرجاء إنشاء مجمع أولاً',
    'create': 'إنشاء وحدات معرض',
    'unnamed_building': 'مجمع بدون اسم',
    'no_address_provided': 'لا يوجد عنوان',

    'select_building_for_bulk_creation': 'اختر المجمع لإضافة وحدات معرض بالجملة',

    'loading_building_details': 'جاري تحميل تفاصيل المجمع...',
    'error_loading_building': 'خطأ في تحميل المجمع',
    'try_again': 'حاول مرة أخرى',
    'back_to_buildings': 'العودة إلى المجمعات',
    'building_not_found': 'المجمع غير موجود',
    'building_not_found_message': 'المجمع الذي تبحث عنه غير موجود أو تم إزالته.',
    'add_apartment': 'إضافة وحدة معرض',
    'edit_building': 'تعديل المجمع',
    'generate_reports': 'إنشاء تقارير',
    'total_apartments': 'إجمالي وحدات المعرض',
    'units': 'وحدة',
    'across_floors': 'عبر {{floors}} مستويات',
    'vacant_apartments': 'شاغرة',
    'available_for_rent': 'متاحة للإيجار',
    'no_vacancies': 'لا توجد وحدات معرض شاغرة',
    'occupancy_rate': 'معدل الإشغال',
    'occupied_units': 'وحدات مشغولة',
    'maintenance_apartments': 'صيانة',
    'needs_attention': 'تحتاج إلى اهتمام',
    'average_apartment_size': 'متوسط المساحة',
    'furnished_apartments': 'مجهزة بمرافق',
    'utility_status': 'حالة المرافق',
    'water': 'ماء',
    'electricity': 'كهرباء',
    'internet': 'إنترنت',
    'hide_details': 'إخفاء التفاصيل',
    'show_details': 'عرض التفاصيل',
    'search_apartments': 'ابحث عن وحدات معرض، ملاك، مستأجرين...',
    'all_statuses': 'جميع الحالات',
    'vacant': 'شاغرة',
    'occupied': 'مشغولة',
    'maintenance': 'صيانة',
    'top_floor_first': 'المستوى العلوي أولاً',
    'ground_floor_first': 'المستوى الأرضي أولاً',
    'showing_results': 'عرض {{count}} من {{total}} وحدة معرض',
    'matching': 'تمستوى',
    'with_status': 'بحالة',
    'no_apartments_found': 'لم يتم العثور على وحدات معرض',
    'no_apartments_match_filters': 'لا توجد وحدات معرض تمستوى عوامل التصفية الحالية.',
    'clear_filters': 'مسح الفلاتر',
    'floor_number': 'المستوى {{number}}',
    'apartments': 'وحدات معرض',
    'owner': 'المالك',
    'status': 'الحالة',
    'vacant_status': 'متاحة',
    'maintenance_status': 'تحت الصيانة',
    'furnished': 'مجهزة بمرافق',
    'unfurnished': 'غير مجهزة بمرافق',
    'no_matching_apartments_on_floor': 'لا توجد وحدات معرض في المستوى {{floor}} تمستوى عوامل التصفية الحالية.',
    'construction_year': 'سنة البناء: {{year}}',

    'activity_logs': 'سجل النشاطات',
    'track_all_system_activities': 'تتبع جميع نشاطات النظام والتغييرات',
    'filter': 'تصفية',
    'export_to_excel': 'تصدير إلى إكسل',
    'exporting': 'جاري التصدير...',
    'filter_logs': 'تصفية السجلات',
    'action_type': 'نوع الإجراء',
    'all_actions': 'جميع الإجراءات',
    'entity_type': 'نوع الكيان',
    'all_entities': 'جميع الكيانات',
    'entries_per_page': 'عدد المدخلات لكل صفحة',
    'start_date': 'تاريخ البدء',
    'end_date': 'تاريخ الانتهاء',
    'reset': 'إعادة تعيين',
    'apply_filter': 'تطبيق التصفية',
    'previous': 'السابق',
    'next': 'التالي',
    'tenant_activity_logs': 'سجل نشاطات المستأجرين',
    'payment_activity_logs': 'سجل نشاطات الدفعات',
    'building_activity_logs': 'سجل نشاطات المجمعات',
    'apartment_activity_logs': 'سجل نشاطات وحدات المعرض',
    'owner_activity_logs': 'سجل نشاطات الملاك',
    'user_activity_logs': 'سجل نشاطات المستخدمين',
    'system_activity_logs': 'سجل نشاطات النظام',

    'monthly_revenue_by_user': 'الإيرادات الشهرية حسب المستخدم',
    'export_to_excel': 'تصدير إلى إكسل',
    'exporting': 'جاري التصدير...',
    'total_revenue': 'إجمالي الإيرادات',
    'total_payments': 'إجمالي المدفوعات',
    'recorded_by': 'مسجل بواسطة',
    'average_payment': 'متوسط المدفوعات',
    'per_transaction': 'لكل معاملة',
    'revenue_by_user': 'الإيرادات حسب المستخدم',
    'no_revenue_data': 'لا توجد بيانات إيرادات',
    'no_revenue_data_message': 'لا توجد سجلات مدفوعات لـ {{month}} {{year}}. حاول اختيار شهر أو سنة مختلفة.',

    'loading_owner_data': 'جاري تحميل بيانات المالك',
    'error_loading_owner': 'خطأ في تحميل المالك',
    'back_to_owners': 'العودة إلى الملاك',
    'send_reminder': 'إرسال تذكير',
    'edit': 'تعديل',
    'overview': 'نظرة عامة',
    'properties': 'وحدات المعرض',
    'payments': 'المدفوعات',
    'outstanding': 'المستحقات',
    'contact_information': 'معلومات الاتصال',
    'property_overview': 'نظرة عامة على المجمعات',
    'add_apartment': 'إضافة وحدة معرض',
    'no_properties': 'لا توجد وحدات معرض',
    'no_properties_message': 'هذا المالك لا يمتلك أي وحدات معرض بعد.',
    'add_first_property': 'إضافة أول وحدة معرض',
    'view_details': 'عرض التفاصيل',
    'payment_history': 'سجل المدفوعات',
    'no_payments': 'لا توجد مدفوعات',
    'no_payments_message': 'لم يتم تسجيل أي مدفوعات بعد.',
    'outstanding_fees': 'المستحقات المعلقة',
    'no_outstanding_fees': 'لا توجد مستحقات معلقة',
    'all_fees_paid': 'جميع المستحقات محدثة.',
    'total_outstanding': 'إجمالي المستحقات',
    'add_payment': 'إضافة دفعة',
    'property': 'وحدة المعرض',
    'select_property': 'اختر وحدة معرض',
    'amount': 'المبلغ',
    'payment_date': 'تاريخ الدفع',
    'payment_method': 'طريقة الدفع',
    'cash': 'نقداً',
    'bank_transfer': 'تحويل بنكي',
    'check': 'شيك',
    'credit_card': 'بطاقة ائتمان',
    'online_payment': 'دفع إلكتروني',
    'reference_number': 'رقم المرجع',
    'notes': 'ملاحظات',
    'cancel': 'إلغاء',

    'owner_information': 'معلومات المالك',
    'name': 'الاسم',
    'phone': 'الهاتف',
    'owner_lives_property': 'يعمل هناك',
    'select_apartments': 'اختر وحدات المعرض',
    'available_apartments': 'وحدات معرض متاحة',
    'no_apartments_available': 'لا توجد وحدات معرض متاحة. جميع وحدات المعرض لديها ملاك بالفعل.',
    'apartment_number': 'وحدة المعرض {{number}}',
    'floor': 'المستوى',
    'size': 'المساحة',
    'type': 'النوع',
    'status': 'الحالة',
    'cancel': 'إلغاء',
    'saving': 'جاري الحفظ...',
    'update_owner': 'تحديث المالك',
    'create_owner': 'إنشاء مالك',
    'edit_property_owner': 'تعديل مالك العقار',
    'add_property_owner': 'إضافة مالك عقار',

    'resident_owner': 'مالك مقيم',
    'apartments_count': 'عدد وحدات المعرض',
    'show_apartments': 'عرض وحدات المعرض',
    'hide_apartments': 'إخفاء وحدات المعرض',
    'size_unit_sqm': 'حجم الوحدة متر مربع',

    'property_owners': 'مالكو المجمعات',
    'add_owner': 'إضافة مالك',
    'search_owners': 'بحث عن الملاك...',
    'filter': 'تصفية',
    'list_view': 'قائمة',
    'grid_view': 'شبكة',
    'export': 'تصدير',
    'exporting': 'جاري التصدير...',
    'living_status': 'حالة السكن',
    'all': 'الكل',
    'living_on_property': 'مقيم في العقار',
    'not_living_on_property': 'غير مقيم في العقار',
    'country': 'البلد',
    'all_countries': 'جميع البلدان',
    'apartment_status': 'حالة وحدة المعرض',
    'all_statuses': 'جميع الحالات',
    'with_vacant': 'مع وحدات معرض شاغرة',
    'fully_occupied': 'مشغول بالكامل',
    'with_maintenance': 'مع صيانة',
    'min_apartments': 'الحد الأدنى للوحدات معرض',
    'max_apartments': 'الحد الأقصى للوحدات معرض',
    'min_occupancy_rate': 'نسبة الإشغال الدنيا (%)',
    'clear_filters': 'مسح الفلاتر',
    'apply_filters': 'تطبيق الفلاتر',
    'total_owners': 'إجمالي الملاك',
    'resident_owners': 'الملاك المقيمين',
    'with_apartments': 'مع وحدات معرض',
    'without_apartments': 'بدون وحدات معرض',
    'loading_owners': 'جاري تحميل الملاك...',
    'error_loading_owners': 'خطأ في تحميل الملاك',
    'try_again': 'حاول مرة أخرى',
    'no_owners_found': 'لم يتم العثور على ملاك',
    'no_owners_message': 'لا يوجد ملاك للعقارات في النظام حتى الآن. انقر فوق زر \'إضافة مالك\' لإنشاء أول مالك لك.',
    'create_first_owner': 'إنشاء أول مالك',
    'showing_filtered_results': 'عرض {showing} من أصل {total} من الملاك',
    'confirm_deletion': 'تأكيد الحذف',
    'delete_owner_confirmation': 'هل أنت متأكد أنك تريد حذف المالك "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'cancel': 'إلغاء',
    'delete': 'حذف',
    'deleting': 'جاري الحذف...',

    "loading": "جاري التحميل...",
    "edit_property_owner": "تعديل مالك العقار",
    "add_property_owner": "إضافة مالك عقار",
    "owner_information": "معلومات المالك",
    "name": "الاسم",
    "phone": "رقم الهاتف",
    "owner_lives_on_property": "يعمل هناك",
    "select_apartments": "اختر وحدات المعرض ({{count}})",
    "available_apartments": "{{count}} وحدة معرض متاحة",
    "no_apartments_available": "لا توجد وحدات معرض متاحة. جميع وحدات المعرض لديها مالكون بالفعل.",
    "floor": "المستوى",
    "size": "المساحة",
    "size_unit_sqm": "م²",
    "type": "النوع",
    "status": "الحالة",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "update_owner": "تحديث المالك",
    "create_owner": "إنشاء مالك",
    "failed_to_load_data": "فشل في تحميل البيانات",
    "failed_to_save_owner": "فشل في حفظ بيانات المالك",

    "activity_logs": "سجلات النشاط",
    "tenant_activity_logs": "سجلات نشاط المستأجرين",
    "payment_activity_logs": "سجلات نشاط المدفوعات",
    "building_activity_logs": "سجلات نشاط المجمعات",
    "apartment_activity_logs": "سجلات نشاط وحدات المعرض",
    "owner_activity_logs": "سجلات نشاط المالكين",
    "user_activity_logs": "سجلات نشاط المستخدمين",
    "system_activity_logs": "سجلات نشاط النظام",
    "track_all_system_activities": "تتبع جميع أنشطة وتغييرات النظام",
    "filter": "تصفية",
    "export_to_excel": "تصدير إلى إكسل",
    "exporting": "جاري التصدير...",
    "search_logs_placeholder": "البحث في السجلات حسب الاسم أو المستخدم أو التفاصيل...",
    "showing_entries": "عرض {{showing}} من {{total}} سجل",
    "filter_logs": "تصفية السجلات",
    "action_type": "نوع الإجراء",
    "all_actions": "جميع الإجراءات",
    "entity_type": "نوع الكيان",
    "all_entities": "جميع الكيانات",
    "entries_per_page": "عدد السجلات في الصفحة",
    "start_date": "تاريخ البدء",
    "end_date": "تاريخ الانتهاء",
    "reset": "إعادة تعيين",
    "apply_filter": "تطبيق التصفية",
    "time": "الوقت",
    "user": "المستخدم",
    "action": "الإجراء",
    "entity": "الكيان",
    "details": "التفاصيل",
    "view": "عرض",
    "system": "النظام",
    "view_entity_details": "عرض تفاصيل {{type}}",
    "no_logs_matching_search": "لا توجد سجلات نشاط تمستوى معايير البحث",
    "no_logs_for_filters": "لا توجد سجلات نشاط للفلاتر المحددة",
    "showing_range": "عرض {{start}} إلى {{end}} من {{total}} سجل",
    "previous": "السابق",
    "next": "التالي",
    "failed_to_load_logs": "فشل في تحميل سجلات النشاط",
    "failed_to_export_logs": "فشل في تصدير السجلات إلى إكسل",

    "tenant": "مستأجر",
    "payment": "دفعة",
    "building": "مجمع",
    "apartment": "وحدة معرض",
    "owner": "مالك",
    "user": "مستخدم",
    "system": "نظام",

    "created": "تم الإنشاء",
    "updated": "تم التحديث",
    "deleted": "تم الحذف",
    "viewed": "تم العرض",
    "login": "تسجيل الدخول",
    "logout": "تسجيل الخروج",
    "payment_made": "تم الدفع",
    "payment_received": "تم استلام الدفعة",
    "status_changed": "تم تغيير الحالة",
    "approved": "تمت الموافقة",
    "rejected": "تم الرفض",
    "maintenance_request": "طلب صيانة",
    "maintenance_completed": "اكتملت الصيانة",


    "loading": "جاري التحميل...",
    "edit_payment": "تعديل الدفعة",
    "record_payment": "تسجيل دفعة",
    "payment_information": "معلومات الدفع",
    "tenant": "المستأجر",
    "select_tenant": "اختر المستأجر",
    "apt": "وحدة معرض",
    "no_apartment": "لا توجد وحدة معرض",
    "amount": "المبلغ",
    "payment_date": "تاريخ الدفع",
    "payment_type": "نوع الدفعة",
    "payment_period": "فترة الدفع",
    "period_start": "بداية الفترة",
    "period_end": "نهاية الفترة",
    "additional_information": "معلومات إضافية",
    "notes": "ملاحظات",
    "notes_placeholder": "أي ملاحظات إضافية حول هذه الدفعة...",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "update_payment": "تحديث الدفعة",
    "failed_to_load_tenants_format": "فشل في تحميل المستأجرين: صيغة بيانات غير متوقعة",
    "failed_to_load_tenants": "فشل في تحميل المستأجرين. يرجى المحاولة مرة أخرى.",
    "failed_to_load_payment_data": "فشل في تحميل بيانات الدفع",
    "failed_to_save_payment": "فشل في حفظ الدفعة",

    "rent": "إيجار",
    "service": "رسوم خدمة",
    "deposit": "تأمين",
    "maintenance": "صيانة",
    "other": "أخرى",

    "payments": "المدفوعات",
    "refresh": "تحديث",
    "refresh_payments": "تحديث المدفوعات",
    "stats": "إحصائيات",
    "toggle_statistics": "تبديل عرض الإحصائيات",
    "search_payments": "ابحث في المدفوعات...",
    "filter": "تصفية",
    "record_payment": "تسديد دفعة",
    "confirm_deletion": "تأكيد الحذف",
    "confirm_delete_payment": "هل أنت متأكد أنك تريد حذف دفعة {amount} للمستأجر {tenantName}؟ لا يمكن التراجع عن هذا الإجراء.",
    "cancel": "إلغاء",
    "deleting": "جاري الحذف...",
    "delete": "حذف",
    "filter_payments": "تصفية المدفوعات",
    "reset_all": "إعادة تعيين الكل",
    "payment_type": "نوع الدفعة",
    "all_types": "جميع الأنواع",
    "payment_type_rent": "إيجار",
    "payment_type_service": "خدمة",
    "payment_type_deposit": "وديعة",
    "payment_type_other": "أخرى",
    "building": "المجمع",
    "all_buildings": "جميع المجمعات",
    "from_date": "من تاريخ",
    "to_date": "إلى تاريخ",
    "total_payments": "إجمالي المدفوعات",
    "payment": "دفعة",
    "payments": "مدفوعات",
    "recorded": "مسجلة",
    "rent_payments": "مدفوعات الإيجار",
    "service_payments": "مدفوعات الخدمة",
    "payment_statistics": "إحصائيات المدفوعات",
    "payments_by_month": "المدفوعات حسب الشهر",
    "payment_types_distribution": "توزيع أنواع المدفوعات",
    "recent_activity": "النشاط الأخير",
    "close_statistics": "إغلاق الإحصائيات",
    "loading_payments": "جاري تحميل المدفوعات...",
    "this_may_take_moment": "قد يستغرق هذا بعض الوقت",
    "error_loading_payments": "خطأ في تحميل المدفوعات",
    "try_again": "حاول مرة أخرى",
    "no_payments_found": "لا توجد مدفوعات",
    "no_payments_match_filters": "لا توجد مدفوعات تمستوى عوامل التصفية الحالية. حاول تعديل معايير التصفية لرؤية المزيد من النتائج.",
    "no_payments_in_system": "لا توجد مدفوعات في النظام بعد. ابدأ بتسجيل أول دفعة.",
    "reset_filters": "إعادة تعيين الفلاتر",
    "record_first_payment": "تسجيل أول دفعة",
    "unknown_period": "فترة غير معروفة",
    "to": "إلى",
    "invalid_period_data": "بيانات فترة غير صالحة",
    "unknown_type": "نوع غير معروف",
    "apt": "وحدة معرض",
    "print_receipt": "طباعة الإيصال",
    "view_details": "عرض التفاصيل",
    "edit_payment": "تعديل الدفعة",
    "delete_payment": "حذف الدفعة",
    "showing_payments": "عرض {start}-{end} من أصل {total} مدفوعات",
    "showing_filtered_payments": "عرض {filtered} من أصل {total} مدفوعات بناءً على بحثك",
    "authentication_required": "مطلوب مصادقة",
    "failed_load_payments": "فشل تحميل بيانات المدفوعات",
    "auth_failed_login_again": "فشل المصادقة. يرجى تسجيل الدخول مرة أخرى.",
    "access_denied_admin_required": "تم الرفض. مطلوب دور المسؤول.",
    "server_error_check_backend": "خطأ في الخادم. يرجى التحقق مما إذا كان الخلفية قيد التشغيل.",
    "cannot_connect_server": "لا يمكن الاتصال بالخادم. يرجى التحقق مما إذا كان الخلفية قيد التشغيل.",
    "error_fetching_payments": "خطأ في جلب المدفوعات",
    "error_deleting_payment": "خطأ في حذف الدفعة",
    "failed_delete_payment": "فشل حذف الدفعة",

    "occupancy_report": "تقرير الإشغال",
    "loading": "جاري التحميل...",
    "refresh": "تحديث",
    "back": "رجوع",
    "error_fetching_occupancy": "خطأ في جلب بيانات الإشغال",
    "failed_load_occupancy": "فشل تحميل بيانات الإشغال",
    "occupied": "مشغولة",
    "vacant": "شاغرة",
    "maintenance": "صيانة",
    "apartments": "وحدات معرض",
    "occupancy_rate": "معدل الإشغال",
    "of": "من",
    "vacant_apartments": "وحدات المعرض الشاغرة",
    "of_total": "من الإجمالي",
    "maintenance_apartments": "قيد الصيانة",
    "potential_income": "الدخل الشهري المحتمل",
    "buildings": "مجمعات",
    "occupancy_distribution": "توزيع الإشغال",
    "occupancy_by_building": "الإشغال حسب المجمع",
    "building": "المجمع",
    "total_apartments": "إجمالي وحدات المعرض",
    "print_report": "طباعة التقرير",
    "export_report": "تصدير التقرير",

    "rent": "إيجار",
    "service": "خدمة",
    "commission": "عمولة",
    "insurance": "تأمين",
    "total": "المجموع",

    "occupied": "مشغولة",
    "vacant": "شاغرة",
    "maintenance": "صيانة",
    "apartments": "وحدات معرض",
    "of": "من",
    "excellent": "ممتاز",
    "good": "جيد",
    "needs_improvement": "يحتاج تحسين",
    "error_fetching_occupancy": "خطأ في جلب بيانات الإشغال",
    "failed_load_occupancy": "فشل تحميل بيانات الإشغال",


    "overdue": "متأخر",
    "pending": "قيد الانتظار",
    "paid": "مدفوع",
    "no_overdue_payments": "لا توجد مدفوعات متأخرة",
    "apt": "وحدة معرض",
    "days_overdue": "يوم متأخر",
    "more_overdue_tenants": "مستأجرين متأخرين إضافيين...",
    "error_fetching_tenant_status": "خطأ في جلب حالة دفع المستأجر",
    "failed_load_tenant_status": "فشل تحميل حالة دفع المستأجر",

    "rent": "إيجار",
    "service": "خدمة",
    "deposit": "وديعة",
    "no_recent_payments": "لا توجد مدفوعات حديثة",
    "error_fetching_payments": "خطأ في جلب المدفوعات الحديثة",
    "failed_load_payments": "فشل تحميل المدفوعات الحديثة",

    "payment_logs": "سجلات الدفع",
    "filter": "تصفية",
    "back": "رجوع",
    "search_payment_logs_placeholder": "البحث في سجلات الدفع...",
    "showing_entries": "عرض {{showing}} من {{total}} سجل",
    "filter_payments": "تصفية المدفوعات",
    "time_period": "الفترة الزمنية",
    "start_date": "تاريخ البداية",
    "end_date": "تاريخ النهاية",
    "payment_type": "نوع الدفع",
    "all_types": "جميع الأنواع",
    "entries_per_page": "عدد السجلات في الصفحة",
    "reset": "إعادة تعيين",
    "apply_filter": "تطبيق التصفية",
    "payment_id": "رقم الدفعة",
    "date": "التاريخ",
    "tenant": "المستأجر",
    "building": "المجمع",
    "type": "النوع",
    "amount": "المبلغ",
    "actions": "الإجراءات",
    "print_receipt": "طباعة الإيصال",
    "view_details": "عرض التفاصيل",
    "no_logs_matching_search": "لا توجد سجلات دفع تمستوى معايير البحث",
    "no_logs_for_period": "لا توجد سجلات دفع متاحة للفترة الزمنية المحددة",
    "showing_range": "عرض {{start}} إلى {{end}} من {{total}} سجل",
    "previous": "السابق",
    "next": "التالي",
    "print_report": "طباعة التقرير",
    "export_to_excel": "تصدير إلى إكسل",
    "failed_to_load_payment_logs": "فشل في تحميل سجلات الدفع",

    "current_month": "الشهر الحالي",
    "last_month": "الشهر الماضي",
    "current_quarter": "الربع الحالي",
    "current_year": "السنة الحالية",
    "custom": "نطاق مخصص",

    "rent": "إيجار",
    "service": "خدمة",
    "commission": "عمولة",
    "reports_dashboard": "لوحة التقارير",
    "overview_of_financial_performance": "نظرة عامة على الأداء المالي وإحصاءات المجمعات",
    "view_all_reports": "عرض جميع التقارير",
    "failed_to_load_report_data": "فشل في تحميل بيانات التقرير",
    "filters": "الفلاتر",
    "search_tenants_placeholder": "البحث عن مستأجر حسب الاسم أو الهاتف أو وحدة المعرض",
    "active_tenants": "المستأجرون النشطون",
    "inactive_tenants": "المستأجرون غير النشطين",
    "with_apartments": "مع وحدات معرض",
    "without_apartments": "بدون وحدات معرض",
    "tenants_management": "إدارة المستأجرين",
    "manage_tenants_and_leases": "إدارة المستأجرين والعقود",
    "add_tenant": "إضافة مستأجر",
    "terminate_contract": "إنهاء العقد",
    "total_revenue": "إجمالي الإيرادات",
    "total_payments_count": "{{count}} دفعة",
    "total_tenants": "إجمالي المستأجرين",
    "new_tenants_this_year": "{{count}} جديد هذا العام",
    "total_properties": "إجمالي المجمعات",
    "total_buildings_count": "{{count}} مجمع",
    "total_owners": "إجمالي الملاك",
    "ended_contracts_count": "{{count}} عقد منتهي",
    "monthly_revenue_year": "الإيرادات الشهرية - {{year}}",
    "view_details": "عرض التفاصيل",
    "occupancy_rate": "معدل الإشغال",
    "recent_payments": "الدفعات الأخيرة",
    "view_all": "عرض الكل",
    "overdue_payments": "الدفعات المتأخرة",
    "quick_reports": "تقارير سريعة",
    "annual_revenue": "الإيرادات السنوية",
    "yearly_breakdown": "تفصيل سنوي لجميع الإيرادات",
    "building_revenue": "إيرادات المجمعات",
    "revenue_by_building": "تفصيل الإيرادات حسب المجمع",
    "owner_revenue": "إيرادات الملاك",
    "revenue_by_owner": "تفصيل الإيرادات حسب مالك العقار",
    "payment_logs": "سجلات الدفع",
    "detailed_payment_history": "سجل مفصل لتاريخ الدفعات",


    "revenue_report": "تقرير الإيرادات",
    "filter": "تصفية",
    "loading": "جاري التحميل...",
    "refresh": "تحديث",
    "back": "رجوع",
    "filter_report": "تصفية التقرير",
    "time_period": "الفترة الزمنية",
    "start_date": "تاريخ البداية",
    "end_date": "تاريخ النهاية",
    "cancel": "إلغاء",
    "apply_filter": "تطبيق التصفية",
    "failed_to_load_revenue_data": "فشل في تحميل بيانات الإيرادات",
    "total_revenue": "إجمالي الإيرادات",
    "total_payments_count": "{{count}} دفعة",
    "rent_revenue": "إيرادات الإيجار",
    "percent_of_total": "{{percent}}% من الإجمالي",
    "service_revenue": "إيرادات الخدمات",
    "unique_tenants": "المستأجرين الفريدين",
    "avg_per_tenant": "متوسط {{amount}} لكل مستأجر",
    "revenue_by_building": "الإيرادات حسب المجمع",
    "view_details": "عرض التفاصيل",
    "building": "المجمع",
    "tenants": "المستأجرين",
    "no_building_revenue_data": "لا توجد بيانات إيرادات متاحة للمجمعات",
    "revenue_by_owner": "الإيرادات حسب المالك",
    "owner": "المالك",
    "apartments": "وحدات المعرض",
    "no_owner_revenue_data": "لا توجد بيانات إيرادات متاحة للملاك",
    "print_report": "طباعة التقرير",
    "export_report": "تصدير التقرير",

    "current_month": "الشهر الحالي",
    "last_month": "الشهر الماضي",
    "current_quarter": "الربع الحالي",
    "current_year": "السنة الحالية",
    "custom": "نطاق مخصص",


    "service_payments_management": "إدارة مدفوعات الخدمات",
    "refresh": "تحديث",
    "back_to_dashboard": "العودة إلى لوحة المعلومات",
    "building": "المجمع",
    "select_building": "اختر المجمع",
    "year": "السنة",
    "search": "بحث",
    "search_apartments_tenants": "البحث عن وحدات معرض، مستأجرين...",
    "generate_payments": "إنشاء المدفوعات",
    "view_statistics": "عرض الإحصائيات",
    "filter_by_status": "تصفية حسب الحالة",
    "all": "الكل",
    "paid": "مدفوع",
    "unpaid": "غير مدفوع",
    "clear_filters": "مسح التصفية",
    "loading_service_data": "جاري تحميل بيانات مدفوعات الخدمات...",
    "no_building_selected": "لم يتم اختيار مجمع",
    "please_select_building": "الرجاء اختيار مجمع لعرض مدفوعات الخدمات.",
    "no_search_results": "لا توجد نتائج بحث",
    "no_matching_apartments": "لا توجد وحدات معرض أو مستأجرين تمستوى معايير البحث.",
    "service_payments_for_building_year": "مدفوعات الخدمات لـ {{building}} - {{year}}",
    "floor_number": "المستوى {{number}}",
    "apartments": "وحدات معرض",
    "rate": "معدل",
    "tenant_owner": "المستأجر/المالك",
    "vacant": "شاغر",
    "mark_as_paid": "تعليم كمدفوع",
    "mark_as_unpaid": "تعليم كغير مدفوع",
    "view_details": "عرض التفاصيل",
    "summary": "ملخص",
    "floor_apartment_count": "{{floors}} منطقة، {{apartments}} وحدة معرض",
    "zone_showroom_count": "{{zones}} منطقة، {{showrooms}} وحدة معرض",
    "no_floors_available": "لا توجد مستويات متاحة",
    "no_floors_message": "لا توجد مستويات بها وحدات معرض في هذا المجمع، أو لم يتم إنشاء مدفوعات الخدمات بعد.",
    "failed_to_load_buildings": "فشل في تحميل المجمعات. الرجاء المحاولة مرة أخرى.",
    "failed_to_load_floors": "فشل في تحميل المستويات",
    "failed_to_load_building_floors": "فشل في تحميل مستويات المجمع",
    "failed_to_load_floor_data": "فشل في تحميل بيانات المستوى",
    "data_refreshed_successfully": "تم تحديث البيانات بنجاح.",
    "failed_to_refresh_data": "فشل في تحديث البيانات",
    "marked_as_paid_via_service_management": "تم تعليمه كمدفوع عبر إدارة الخدمات",
    "marked_as_unpaid_via_service_management": "تم تعليمه كغير مدفوع عبر إدارة الخدمات",
    "payment_marked_as_paid": "تم تعليم الدفعة كمدفوعة بنجاح.",
    "payment_marked_as_unpaid": "تم تعليم الدفعة كغير مدفوعة بنجاح.",
    "failed_to_update_payment": "فشل في تحديث الدفعة",
    "payment_details": "تفاصيل الدفعة",
    "payment_due": "دفعة مستحقة",
    "amount": "المبلغ",
    "status": "الحالة",
    "paid_on": "تم الدفع في",
    "no_apartments_on_floor": "لا توجد وحدات معرض في هذا المستوى.",

    "month_1": "يناير",
    "month_2": "فبراير",
    "month_3": "مارس",
    "month_4": "أبريل",
    "month_5": "مايو",
    "month_6": "يونيو",
    "month_7": "يوليو",
    "month_8": "أغسطس",
    "month_9": "سبتمبر",
    "month_10": "أكتوبر",
    "month_11": "نوفمبر",
    "month_12": "ديسمبر",

    "service_payment_details": "تفاصيل دفعة الخدمة",
    "print_receipt": "طباعة الإيصال",
    "loading": "جاري التحميل...",
    "failed_to_load_payment_details": "فشل في تحميل تفاصيل الدفعة",
    "api_endpoint_missing_message": "يشير هذا الخطأ إلى نقطة نهاية API مفقودة على خادم الواجهة الخلفية. لإصلاح ذلك، أضف مسارًا لـ GET /api/services/:id في ملف serviceRoutes.js الخاص بك.",
    "payment_information": "معلومات الدفع",
    "apartment": "وحدة المعرض",
    "period": "الفترة",
    "amount": "المبلغ",
    "status": "الحالة",
    "tenant": "المستأجر",
    "owner": "المالك",
    "payment_date": "تاريخ الدفع",
    "paid_by": "دفع بواسطة",
    "notes": "ملاحظات",
    "update_payment": "تحديث الدفعة",
    "mark_as_paid": "تعليم كمدفوع",
    "currency": "العملة",
    "select_payer": "اختر الدافع",
    "management": "الإدارة",
    "other": "آخر",
    "payment_notes_placeholder": "أدخل أي ملاحظات إضافية حول هذه الدفعة...",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "payment_history": "سجل الدفعات",
    "date": "التاريخ",
    "action": "الإجراء",
    "by": "بواسطة",
    "paid": "مدفوع",
    "unpaid": "غير مدفوع",
    "payment_marked_as_paid": "تم تعليم الدفعة كمدفوعة بنجاح.",
    "payment_marked_as_unpaid": "تم تعليم الدفعة كغير مدفوعة بنجاح.",
    "failed_to_update_payment": "فشل في تحديث الدفعة",
    "service_payment_receipt": "إيصال دفع الخدمة",
    "property_management": "إدارة المجمعات",
    "receipt_generated": "تم إنشاء هذا الإيصال في {{date}} الساعة {{time}}",
    "automated_receipt_notice": "هذا إيصال تم إنشاؤه تلقائيًا ولا يتطلب توقيعًا.",
    "us_dollar": "دولار أمريكي",
    "iraqi_dinar": "دينار عراقي",
    "euro": "يورو",

    "month_1": "يناير",
    "month_2": "فبراير",
    "month_3": "مارس",
    "month_4": "أبريل",
    "month_5": "مايو",
    "month_6": "يونيو",
    "month_7": "يوليو",
    "month_8": "أغسطس",
    "month_9": "سبتمبر",
    "month_10": "أكتوبر",
    "month_11": "نوفمبر",
    "month_12": "ديسمبر",

    "tenant": "مستأجر",
    "owner": "مالك",
    "management": "إدارة",
    "other": "آخر",

    "generate_service_payments": "إنشاء مدفوعات الخدمة",
    "recipients": "المستلمون",
    "entire_building": "المجمع بأكمله",
    "generate_for_all_apartments": "إنشاء لجميع وحدات المعرض في المجمع",
    "specific_tenants": "المستأجرين المحددين",
    "generate_for_selected_tenants": "إنشاء للمستأجرين المحددين فقط",
    "specific_owners": "المالكين المحددين",
    "generate_for_selected_owners": "إنشاء للمالكين المحددين فقط",
    "select_building": "اختر المجمع",
    "include_vacant_apartments": "تضمين وحدات المعرض الشاغرة",
    "selected_tenants": "المستأجرين المحددين",
    "selected_owners": "المالكين المحددين",
    "select_tenants": "اختر المستأجرين",
    "select_owners": "اختر المالكين",
    "no_tenants_selected": "لم يتم اختيار مستأجرين",
    "no_owners_selected": "لم يتم اختيار مالكين",
    "payment_details": "تفاصيل الدفع",
    "amount": "المبلغ",
    "currency": "العملة",
    "us_dollar": "دولار أمريكي",
    "iraqi_dinar": "دينار عراقي",
    "euro": "يورو",
    "initial_status": "الحالة الأولية",
    "unpaid": "غير مدفوع",
    "paid": "مدفوع",
    "notes": "ملاحظات",
    "payment_notes_placeholder": "أدخل أي ملاحظات إضافية حول هذه المدفوعات...",
    "time_period": "الفترة الزمنية",
    "generation_type": "نوع الإنشاء",
    "single_month": "شهر واحد",
    "multiple_months": "عدة أشهر",
    "month_range": "نطاق شهري",
    "year": "السنة",
    "month": "الشهر",
    "select_months": "اختر الأشهر",
    "from": "من",
    "to": "إلى",
    "selected_months": "الأشهر المحددة",
    "payment_generation_summary": "ملخص إنشاء المدفوعات",
    "all_apartments_in": "جميع وحدات المعرض في",
    "selected_building": "المجمع المحدد",
    "tenants": "مستأجرين",
    "owners": "مالكين",
    "cancel": "إلغاء",
    "generating": "جاري الإنشاء...",
    "generate_payments": "إنشاء المدفوعات",
    "search": "بحث",
    "search_by_tenant_name_or_phone": "البحث باسم المستأجر أو الهاتف أو رقم وحدة المعرض...",
    "search_by_owner_name_or_phone": "البحث باسم المالك أو الهاتف...",
    "no_results_found": "لم يتم العثور على نتائج",
    "selected": "محدد",
    "done": "تم",
    "no_tenants_available": "لا يوجد مستأجرين متاحين. الرجاء إضافة مستأجرين أولاً.",
    "no_owners_available": "لا يوجد مالكين متاحين. الرجاء إضافة مالكين أولاً.",
    "apt": "وحدة معرض",
    "january": "يناير",
    "february": "فبراير",
    "march": "مارس",
    "april": "أبريل",
    "may": "مايو",
    "june": "يونيو",
    "july": "يوليو",
    "august": "أغسطس",
    "september": "سبتمبر",
    "october": "أكتوبر",
    "november": "نوفمبر",
    "december": "ديسمبر",
    "failed_to_load_buildings": "فشل في تحميل المجمعات. يرجى المحاولة مرة أخرى.",
    "failed_to_load_tenants": "فشل في تحميل المستأجرين. يرجى المحاولة مرة أخرى.",
    "failed_to_load_owners": "فشل في تحميل المالكين. يرجى المحاولة مرة أخرى.",
    "please_select_building": "الرجاء اختيار مجمع",
    "please_select_at_least_one_recipient": "الرجاء اختيار {{recipient}} واحد على الأقل",
    "please_enter_valid_amount": "الرجاء إدخال مبلغ صحيح",
    "please_select_month": "الرجاء اختيار شهر",
    "please_select_at_least_one_month": "الرجاء اختيار شهر واحد على الأقل",
    "end_month_must_be_after_start_month": "يجب أن يكون الشهر النهائي بعد الشهر البدائي",
    "successfully_generated_payments": "تم إنشاء {{count}} مدفوعات خدمة عبر {{months}} شهر (أشهر). {{skipped}} مدفوعات تم إنشاؤها مسبقًا.",
    "failed_to_generate_service_payments": "فشل في إنشاء مدفوعات الخدمة",
    "tenant": "مستأجر",
    "owner": "مالك",

    "service_payment_statistics": "إحصائيات مدفوعات الخدمة",
    "back_to_services": "العودة إلى الخدمات",
    "building": "المجمع",
    "year": "السنة",
    "loading_statistics": "جاري تحميل الإحصائيات...",
    "no_building_selected": "لم يتم اختيار مجمع",
    "please_select_building_statistics": "الرجاء اختيار مجمع لعرض إحصائيات مدفوعات الخدمة.",
    "overall_statistics": "الإحصائيات العامة",
    "total_collection": "إجمالي التحصيل",
    "of": "من",
    "payment_rate": "معدل الدفع",
    "payments": "مدفوعات",
    "outstanding_amount": "المبلغ المستحق",
    "unpaid_payments": "مدفوعات غير مسددة",
    "monthly_statistics": "الإحصائيات الشهرية",
    "no_monthly_data": "لا توجد بيانات شهرية متاحة للسنة المحددة.",
    "month": "الشهر",
    "total_amount": "إجمالي المبلغ",
    "collected": "تم تحصيله",
    "outstanding": "مستحق",
    "progress": "التقدم",
    "failed_to_load_service_statistics": "فشل في تحميل إحصائيات الخدمة",

    "loading_tenant_data": "جاري تحميل بيانات المستأجر...",
    "error_loading_tenant": "خطأ في تحميل المستأجر",
    "tenant_not_found": "المستأجر غير موجود",
    "back_to_tenants": "العودة إلى المستأجرين",
    "record_payment": "تسجيل دفعة",
    "edit": "تعديل",
    "status_unknown": "الحالة غير معروفة",
    "apartment": "وحدة المعرض",
    "apt": "وحدة معرض",
    "none": "لا يوجد",
    "monthly_rent": "الإيجار الشهري",
    "payment_date": "تاريخ الدفع",
    "overview": "نظرة عامة",
    "leases": "عقود الإيجار",
    "payments": "المدفوعات",
    "contact_information": "معلومات الاتصال",
    "lease_information": "معلومات عقد الإيجار",
    "contract_period": "فترة العقد",
    "rent": "الإيجار",
    "discount": "الخصم",
    "rent_after_discount": "الإيجار بعد الخصم",
    "additional_fees": "الرسوم الإضافية",
    "service_fee": "رسوم الخدمة",
    "office_commission": "عمولة المكتب",
    "insurance": "التأمين",
    "notes": "ملاحظات",
    "no_leases": "لا توجد عقود إيجار",
    "no_leases_message": "هذا المستأجر ليس لديه وحدة معرض مخصصة بعد.",
    "active_leases": "عقود الإيجار النشطة",
    "inactive_leases": "عقود الإيجار غير النشطة",
    "active": "نشط",
    "ended": "منتهي",
    "expiring_soon": "ينتهي قريباً",
    "end_lease": "إنهاء عقد الإيجار",
    "start_date": "تاريخ البدء",
    "end_date": "تاريخ الانتهاء",
    "duration": "المدة",
    "remaining": "المتبقي",
    "months": "أشهر",
    "security_deposit": "مبلغ التأمين",
    "total_value": "القيمة الإجمالية",
    "no_payments": "لا توجد مدفوعات",
    "no_payments_message": "هذا المستأجر ليس لديه مدفوعات مسجلة بعد.",
    "record_first_payment": "تسجيل الدفعة الأولى",
    "payment_period": "فترة الدفع",
    "reference": "المرجع",
    "payment_type": "نوع الدفع",
    "rent_payment": "دفع الإيجار",
    "additional_fee": "رسوم إضافية",
    "utility_payment": "دفع المرافق",
    "other_payment": "دفعة أخرى",
    "start": "البداية",
    "end": "النهاية",
    "reference_number": "رقم المرجع",
    "cancel": "إلغاء",
    "unknown_period": "فترة غير معروفة",
    "invalid_period_format": "تنسيق فترة غير صالح",
    "to": "إلى",
    "invalid_period_data": "بيانات الفترة غير صالحة",
    "please_enter_valid_payment_amount": "الرجاء إدخال مبلغ دفع صحيح",
    "end_date_must_be_after_start_date": "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
    "failed_to_add_payment": "فشل في إضافة الدفعة",
    "maintenance_requests_not_supported": "طلبات الصيانة غير مدعومة في هيكل قاعدة البيانات الحالي",
    "failed_to_create_maintenance_request": "فشل في إنشاء طلب صيانة",
    "confirm_end_lease": "هل أنت متأكد أنك تريد إنهاء عقد الإيجار هذا؟ لا يمكن التراجع عن هذا الإجراء.",
    "lease_ended_by_administrator": "تم إنهاء عقد الإيجار من قبل المسؤول",
    "failed_to_end_lease": "فشل في إنهاء عقد الإيجار",
    "failed_to_load_tenant_data": "فشل في تحميل بيانات المستأجر",
    "actual_end_date": "تاريخ الانتهاء الفعلي",
    "deposit": "تأمين",

    "edit_tenant": "تعديل المستأجر",
    "add_tenant": "إضافة مستأجر",
    "basic_information": "المعلومات الأساسية",
    "first_name": "الاسم الأول",
    "last_name": "اسم العائلة",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "apartment": "وحدة المعرض",
    "select_apartment": "اختر وحدة المعرض",
    "floor": "المستوى",
    "rent_amount": "مبلغ الإيجار",
    "discount": "الخصم",
    "service_fee": "رسوم الخدمة",
    "office_commission": "عمولة المكتب",
    "insurance": "التأمين",
    "contract_start_date": "تاريخ بدء العقد",
    "contract_end_date": "تاريخ انتهاء العقد",
    "payment_date": "تاريخ الدفع",
    "payment_end_date": "تاريخ انتهاء الدفع",
    "rent_status": "حالة الإيجار",
    "additional_information": "معلومات إضافية",
    "notes": "ملاحظات",
    "tenant_notes_placeholder": "أي ملاحظات إضافية حول هذا المستأجر...",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "update_tenant": "تحديث المستأجر",
    "create_tenant": "إنشاء مستأجر",
    "loading": "جاري التحميل...",
    "failed_to_load_tenant_data": "فشل في تحميل بيانات المستأجر",
    "failed_to_save_tenant": "فشل في حفظ المستأجر",
    "pending": "قيد الانتظار",
    "paid": "مدفوع",
    "late": "متأخر",
    "overdue": "متأخر جداً",
    "unpaid": "غير مدفوع",

    "tenants": "المستأجرون",
    "refresh_tenants": "تحديث المستأجرين",
    "selected": "محدد",
    "delete_selected_tenants": "حذف المستأجرين المحددين",
    "search_tenants": "البحث عن المستأجرين...",
    "filter": "تصفية",
    "switch_to_list_view": "التبديل إلى عرض القائمة",
    "switch_to_grid_view": "التبديل إلى عرض الشبكة",
    "list_view": "قائمة",
    "grid_view": "شبكة",
    "hide_inactive_tenants": "إخفاء المستأجرين غير النشطين",
    "show_inactive_tenants": "إظهار المستأجرين غير النشطين",
    "hide_inactive": "إخفاء غير النشطين",
    "show_inactive": "إظهار غير النشطين",
    "add_tenant": "إضافة مستأجر",
    "rent_status": "حالة الإيجار",
    "all_statuses": "جميع الحالات",
    "all_buildings": "جميع المجمعات",
    "all_apartments": "جميع وحدات المعرض",
    "min_rent": "الحد الأدنى للإيجار",
    "max_rent": "الحد الأقصى للإيجار",
    "unlimited": "غير محدود",
    "contracts_ending_before": "العقود التي تنتهي قبل",
    "clear_filters": "مسح التصفية",
    "apply_filters": "تطبيق التصفية",
    "active_tenants": "المستأجرون النشطون",
    "inactive_tenants": "المستأجرون غير النشطين",
    "with_apartments": "مع وحدات معرض",
    "without_apartments": "بدون وحدات معرض",
    "loading_tenants": "جاري تحميل المستأجرين...",
    "error_loading_tenants": "خطأ في تحميل المستأجرين",
    "try_again": "حاول مرة أخرى",
    "no_tenants_found": "لم يتم العثور على مستأجرين",
    "no_tenants_message": "لا يوجد مستأجرين في النظام حتى الآن. انقر على زر 'إضافة مستأجر' لإنشاء أول مستأجر لديك.",
    "create_first_tenant": "إنشاء أول مستأجر",
    "page": "صفحة",
    "showing_items": "عرض {start}-{end} من {total}",
    "first_page": "الصفحة الأولى",
    "previous_page": "الصفحة السابقة",
    "next_page": "الصفحة التالية",
    "last_page": "الصفحة الأخيرة",
    "showing_filtered_results": "عرض {showing} من {total} مستأجر",
    "confirm_deletion": "تأكيد الحذف",
    "delete_tenant_confirmation": "هل أنت متأكد أنك تريد حذف المستأجر \"{name}\"؟ هذا الإجراء لا يمكن التراجع عنه.",
    "cancel": "إلغاء",
    "deleting": "جاري الحذف...",
    "delete": "حذف",
    "tenant": "المستأجر",
    "apartment": "وحدة معرض",
    "rent": "الإيجار",
    "contract": "العقد",
    "status": "الحالة",
    "actions": "الإجراءات",
    "apt": "وحدة معرض",
    "unknown_building": "مجمع غير معروف",
    "no_apartment_assigned": "لم يتم تعيين وحدة معرض",
    "status_unknown": "حالة غير معروفة",
    "monthly_rent": "الإيجار الشهري",
    "after_discount": "بعد الخصم",
    "payment_date": "تاريخ الدفع",
    "not_set": "غير محدد",
    "contract_start": "بداية العقد",
    "contract_end": "نهاية العقد",
    "service": "خدمة",
    "commission": "عمولة",
    "insurance": "تأمين",
    "hide_owner_details": "إخفاء تفاصيل المالك",
    "show_owner_details": "عرض تفاصيل المالك",
    "apartment_owner": "مالك وحدة المعرض",
    "loading_owner_details": "جاري تحميل تفاصيل المالك...",
    "no_owner_information": "لا توجد معلومات عن المالك",
    "lives_on_property": "يعمل هناك",
    "yes": "نعم",
    "works_at_showroom": "يعمل في المعرض",
    "no": "لا",
    "monthly_service_fee_applies": "رسوم الخدمة الشهرية تنطبق",
    "total_apartments": "إجمالي وحدات المعرض",
    "apartment_details": "تفاصيل وحدة المعرض",
    "apartment_number": "رقم وحدة المعرض",
    "unknown": "غير معروف",
    "floor": "المستوى",
    "apartment_type": "نوع وحدة المعرض",
    "standard": "قياسي",
    "furnished": "مجهزة بمرافق",
    "view_owner_profile": "عرض ملف المالك",
    "mark_as_inactive": "تعيين كغير نشط",
    "mark_as_active": "تعيين كنشط",
    "record_payment": "تسجيل دفعة",
    "view_details": "عرض التفاصيل",
    "edit_tenant": "تعديل المستأجر",
    "delete_tenant": "حذف المستأجر",
    "to": "إلى",
    "payment": "الدفع",
    "apartment_financial_details": "تفاصيل وحدة المعرض والمالية",
    "not_authenticated": "غير مصرح. الرجاء تسجيل الدخول.",
    "authentication_required": "التوثيق مطلوب",
    "authentication_failed": "فشل التوثيق. الرجاء تسجيل الدخول مرة أخرى.",
    "access_denied": "تم رفض الوصول. دور المسؤول مطلوب.",
    "server_error": "خطأ في الخادم. يرجى التحقق مما إذا كان الخادم الخلفي يعمل.",
    "cannot_connect_to_server": "لا يمكن الاتصال بالخادم. يرجى التحقق مما إذا كان الخادم الخلفي يعمل على المنفذ 3000.",
    "failed_to_load_tenants_data": "فشل في تحميل بيانات المستأجرين",
    "unknown_error": "خطأ غير معروف",
    "failed_to_delete_tenant": "فشل في حذف المستأجر",
    "confirm_bulk_delete": "هل أنت متأكد أنك تريد حذف {count} مستأجرين؟ هذا الإجراء لا يمكن التراجع عنه.",
    "failed_to_delete_tenants": "فشل في حذف المستأجرين",
    "failed_to_update_tenant_status": "فشل في تحديث حالة المستأجر",
    "pending": "قيد الانتظار",
    "paid": "مدفوع",
    "late": "متأخر",
    "overdue": "متأخر جداً",

    "loading_payment_data": "جاري تحميل بيانات الدفع...",
    "error_loading_payment": "خطأ في تحميل الدفعة",
    "payment_not_found": "لم يتم العثور على الدفعة",
    "back_to_payments": "العودة إلى المدفوعات",
    "confirm_deletion": "تأكيد الحذف",
    "delete_payment_confirmation": "هل أنت متأكد من حذف هذه الدفعة البالغة {{amount}}؟ لا يمكن التراجع عن هذا الإجراء.",
    "cancel": "إلغاء",
    "deleting": "جاري الحذف...",
    "delete": "حذف",
    "print_receipt": "طباعة الإيصال",
    "edit": "تعديل",
    "tenant": "المستأجر",
    "unknown_tenant": "مستأجر غير معروف",
    "apartment": "وحدة المعرض",
    "apt": "وحدة معرض",
    "none": "لا يوجد",
    "payment_period": "فترة الدفع",
    "payment_details": "تفاصيل الدفع",
    "tenant_information": "معلومات المستأجر",
    "payment_information": "معلومات الدفع",
    "amount": "المبلغ",
    "payment_date": "تاريخ الدفع",
    "payment_type": "نوع الدفع",
    "created": "تم الإنشاء",
    "last_updated": "آخر تحديث",
    "notes": "ملاحظات",
    "view_tenant": "عرض المستأجر",
    "unknown_period": "فترة غير معروفة",
    "to": "إلى",
    "invalid_period_data": "بيانات فترة غير صالحة",
    "unknown_type": "نوع غير معروف",
    "unknown": "غير معروف",
    "failed_to_load_payment_data": "فشل في تحميل بيانات الدفع",
    "failed_to_delete_payment": "فشل في حذف الدفعة",

    "rent": "إيجار",
    "service": "رسوم خدمة",
    "deposit": "تأمين",
    "maintenance": "صيانة",
    "other": "أخرى",

    "generate": "أضف",
    "generated": "تمت الإضافة",

    "generate_payment_for": "إنشاء دفعة لـ",
    "payment_amount": "مبلغ الدفع",
    "enter_amount": "أدخل المبلغ",
    "mark_as_paid_immediately": "وضع علامة كمدفوع فوراً",
    "notes": "ملاحظات",
    "payment_notes": "ملاحظات الدفع",
    "required_fields": "الحقول المطلوبة",
    "cancel": "إلغاء",
    "generate_payment": "إنشاء الدفعة",

    'add_new_user': 'إضافة مستخدم جديد',
    'search_users': 'بحث المستخدمين',
    'total_users': 'إجمالي المستخدمين',
    'active_users': 'المستخدمون النشطون',
    'inactive_users': 'المستخدمون غير النشطين',
    'financial_summary': 'الملخص المالي',
    'filters': 'المرشحات',
    'search_tenant_by_name_phone_or_apartment': 'البحث عن المستأجر حسب الاسم أو الهاتف أو وحدة المعرض',
    'view_profile': 'عرض الملف الشخصي',

    // WhatsApp
    'whatsapp_settings': 'إعدادات واتساب',
    'whatsapp_settings_description': 'إشعارات واتساب التلقائية للمستأجرين والملاك',
    'whatsapp_enable': 'تفعيل إشعارات واتساب',
    'whatsapp_enable_sub': 'تشغيل أو إيقاف جميع رسائل واتساب التلقائية',
    'general_settings': 'الإعدادات العامة',
    'default_country_code': 'رمز البلد الافتراضي',
    'tenant_rent_reminder': 'تذكير إيجار المستأجر',
    'tenant_rent_reminder_sub': 'إرسال تذكير للمستأجرين قبل أو بعد موعد الدفع',
    'days_before_due': 'عدد الأيام قبل الاستحقاق',
    'reminder_message_template': 'نص الرسالة',
    'service_fee_reminder': 'تذكير رسوم الخدمة',
    'enable_service_fee_reminder': 'تفعيل تذكير رسوم الخدمة',
    'service_fee_reminder_sub': 'إشعار المستأجرين بمدفوعات الخدمة القادمة',
    'owner_reminder': 'تذكير المالك',
    'enable_owner_reminders': 'تفعيل تذكيرات الملاك',
    'owner_reminder_sub': 'إشعار الملاك عند تأخر المستأجرين في الدفع',
    'owner_message_template': 'نص رسالة المالك',
    'payment_confirmation': 'تأكيد الدفع',
    'send_on_payment': 'إرسال تأكيد عند تسجيل الدفعة',
    'payment_confirmation_sub': 'يُرسل تلقائياً للمستأجر فور تسجيل دفعته',
    'payment_confirmation_template': 'نص رسالة تأكيد الدفع',
    'whatsapp_test_send': 'إرسال رسالة اختبارية',
    'test_message': 'الرسالة',
    'send_test_message': 'إرسال رسالة اختبارية',
    'whatsapp_test_sent': 'تم إرسال رسالة الاختبار!',
    'whatsapp_test_default_message': 'رسالة اختبارية من نظام إدارة المجمعات',
    'send_reminders_now': 'إرسال التذكيرات الآن',
    'send_reminders_now_description': 'إرسال فوري للتذكيرات لجميع المستأجرين والملاك الذين يحتاجونها الآن.',
    'whatsapp_must_be_enabled': 'يجب تفعيل واتساب أولاً',
    'failed_to_load_settings': 'فشل تحميل الإعدادات',
    'settings_saved': 'تم حفظ الإعدادات بنجاح',
    'failed_to_save': 'فشل الحفظ',
    'failed_to_send': 'فشل الإرسال',
    'server_error': 'خطأ في الاتصال بالخادم',
    'sent': 'تم الإرسال',
    'errors': 'أخطاء',
    'skipped': 'تجاوز',

    // Bookings
    'bookings': 'الحجوزات',
    'booking_management': 'إدارة الحجوزات',
    'new_booking': 'حجز جديد',
    'create_booking': 'إنشاء حجز',
    'edit_booking': 'تعديل الحجز',
    'booking_details': 'تفاصيل الحجز',
    'prospect': 'العميل المتوقع',
    'prospect_name': 'اسم العميل',
    'prospect_phone': 'رقم الهاتف',
    'prospect_email': 'البريد الإلكتروني',
    'move_in_date': 'تاريخ الانتقال للسكن',
    'move_out_date': 'تاريخ المغادرة',
    'hold_duration': 'مدة الحجز',
    'hold_hours': 'ساعات الحجز',
    'hold_expiration': 'انتهاء الحجز',
    'internal_notes': 'ملاحظات داخلية',
    'check_availability': 'التحقق من التوفر',
    'checking_availability': 'جاري التحقق من التوفر...',
    'no_bookings_found': 'لم يتم العثور على حجوزات',
    'calendar_view': 'عرض التقويم',
    'waitlist': 'قائمة الانتظار',
    'new_booking_hold': 'حجز وحدة جديد',
    'property_information': 'معلومات العقار',
    'prospect_details': 'تفاصيل العميل',
    'requested_dates': 'التواريخ المطلوبة',
    'conflict_detected': 'تم اكتشاف تعارض',
    'booking_timeline': 'الجدول الزمني للحجوزات',
    'monthly_view_holds': 'عرض شهري للحجوزات النشطة',
    'confirmed_hold': 'حجز مؤكد',
    'pending_payment': 'في انتظار الدفع',
    'move_in': 'تاريخ الدخول',
    'move_out': 'تاريخ الخروج',
    'convert_to_tenant': 'تحويل إلى مستأجر',
    'confirm_booking': 'تأكيد الحجز',
    'cancel_booking': 'إلغاء الحجز',
    'booking_confirmed': 'تم تأكيد الحجز',
    'booking_cancelled': 'تم إلغاء الحجز',
    'booking_converted': 'تم تحويل الحجز إلى مستأجر بنجاح!',
    'process_to_booking': 'تحويل إلى حجز',
    'waitlist_management': 'إدارة قائمة الانتظار',
    'waitlist_empty': 'قائمة الانتظار فارغة',
    'search_waitlist': 'البحث في قائمة الانتظار...',
    'priority': 'الأولوية',
    'desired_unit': 'الوحدة المطلوبة',
    'move_in_preference': 'تفضيل تاريخ الدخول',
    'added': 'تمت الإضافة',
    'rank': 'المرتبة',
    'process_waitlist_success': 'تم التحويل إلى حجز معلق بنجاح!',
    'remove_from_waitlist': 'هل أنت متأكد من حذف هذا الإدخال من قائمة الانتظار؟',
    'entry_removed': 'تم حذف الإدخال',
    'hold_expires': 'ينتهي الحجز',
    'hours': 'ساعات',
    'optional': 'اختياري',
    'apartment_element': 'عنصر وحدة المعرض',
    'select_unit': 'اختر الوحدة',
    'error_loading_data': 'فشل تحميل البيانات',
    'error_saving_booking': 'خطأ في حفظ الحجز',
    'save_changes': 'حفظ التغييرات',
    'select_apartment_move_in_date_error': 'يرجى اختيار وحدة المعرض وتاريخ الدخول للتحقق من التوفر',
    'apartment_available': 'وحدة المعرض متاحة لهذه التواريخ!',
    'error_checking_availability': 'خطأ في التحقق من التوفر',
    'confirm_conflict_booking': 'هناك تعارض في المواعيد. هل أنت متأكد من المتابعة؟',
    'booking_updated': 'تم تحديث الحجز بنجاح',
    'booking_number': 'حجز رقم {{id}}',
    'created_at': 'تم الإنشاء في {{date}}',
    'created_by': 'بواسطة {{name}}',
    'system': 'النظام',
    'confirm': 'تأكيد',
    'target_property': 'العقار المستهدف',
    'furnished': 'مؤثث',
    'unfurnished': 'غير مؤثث',
    'booking_window': 'فترة الحجز',
    'indefinite': 'غير محدد',
    'created_source': 'تم الإنشاء ({{source}})',
    'view_tenant_profile': 'عرض الملف الشخصي للمستأجر',
    'convert_to_active_tenant': 'التحويل إلى مستأجر نشط',
    'lease_details_move_in_instruction': 'أكمل تفاصيل العقد التالية لنقل {{name}} إلى الوحدة {{unit}}.',
    'monthly_rent': 'الإيجار الشهري',
    'first_payment_date': 'تاريخ الدفعة الأولى',
    'contract_start': 'بداية العقد',
    'contract_end': 'نهاية العقد',
    'confirm_convert': 'تأكيد وتحويل',
    'confirm_booking_question': 'هل أنت متأكد من أنك تريد تأكيد هذا الحجز؟',
    'reason_optional': 'يرجى تقديم سبب (اختياري):',
    'amount': 'المبلغ',
    'today': 'اليوم',
    'sun': 'الأحد',
    'mon': 'الأثنين',
    'tue': 'الثلاثاء',
    'wed': 'الأربعاء',
    'thu': 'الخميس',
    'fri': 'الجمعة',
    'sat': 'السبت',
    'more': 'أكثر',
    'close': 'إغلاق',
    'hold_expiration': 'انتهاء صلاحية الحجز',
    'view_details': 'عرض التفاصيل',
    'waitlist_management': 'إدارة قائمة الانتظار',
    'search_waitlist': 'البحث في قائمة الانتظار...',
    'waitlist_empty': 'قائمة الانتظار فارغة',
    'no_prospective_tenants_waiting': 'لا يوجد مستأجرون محتملون ينتظرون توفر وحدات المعرض حالياً.',
    'priority': 'الأولوية',
    'rank': 'المرتبة: {{priority}}',
    'desired_unit': 'الوحدة المطلوبة',
    'move_in_preference': 'تفضيل الانتقال',
    'process_to_booking': 'المعالجة إلى حجز',
    'remove': 'إزالة',
    'remove_waitlist_confirm': 'هل أنت متأكد من رغبتك في إزالة هذا الإدخال من قائمة الانتظار؟',
    'waitlist_processed': 'تم التحويل بنجاح إلى حجز معلق!',
    'entry_removed': 'تمت إزالة الإدخال',
    'failed_process_waitlist': 'فشل معالجة إدخال قائمة الانتظار',
    'failed_remove_entry': 'فشل إزالة الإدخال',
    'booking_analytics': 'إحصائيات الحجز',
    'track_conversion_and_holds': 'تتبع معدلات التحويل ومدة الحجز',
    'last_7_days': 'آخر 7 أيام',
    'last_30_days': 'آخر 30 يوماً',
    'last_90_days': 'آخر 90 يوماً',
    'last_year': 'السنوات الماضية',
    'total_bookings': 'إجمالي الحجوزات',
    'in_selected_period': 'في الفترة المختارة',
    'conversion_rate': 'معدل التحويل',
    'converted_to_tenants': '{{count}} تحولوا إلى مستأجرين',
    'cancellation_rate': 'معدل الإلغاء',
    'cancelled_holds': '{{count}} حجوزات ملغاة',
    'avg_hold_time': 'متوسط وقت الحجز',
    'before_conversion_cancel': 'قبل التحويل/الإلغاء',
    'volume_trends': 'اتجاهات الحجم',
    'no_trend_data': 'لا توجد بيانات اتجاهات متاحة',
    'total_holds': 'إجمالي الحجوزات',
    'status_breakdown': 'تحليل الحالة',
    'no_status_data': 'لا توجد بيانات حالة متاحة',
    'active_holds': 'الحجوزات النشطة',
    'apartment_unit_display': 'وحدة معرض {{number}} - المستوى {{floor}}',
    'pending_move_in': 'قيد الانتظار للانتقال',
    'tenant_name': 'الاسم',
    'tenant_phone': 'رقم الهاتف',
    'tenant_email': 'البريد الإلكتروني',
    'lease_details': 'تفاصيل عقد الإيجار',
    'start_date': 'تاريخ البدء',
    'end_date': 'تاريخ الانتهاء',
    'monthly_pay_date': 'تاريخ الدفع الشهري',
    'day_number': 'يوم {{number}}',
    'duration': 'المدة',
    'months': 'أشهر',
    'remaining_time': 'الوقت المتبقي',
    'financial_summary': 'ملخص مالي',
    'monthly_rent': 'الإيجار الشهري',
    'effective_rent': 'الإيجار الفعلي',
    'rent_status': 'حالة الإيجار',
    'future_tenant_upcoming_move_in': 'المستأجر المستقبلي (انتقال قادم)',
    'move_in_date': 'تاريخ الانتقال',
    'contract_end': 'نهاية العقد',
    'recent_bookings': 'الحجوزات والموافقات الأخيرة',
    'new_hold': 'حجز جديد',
    'available_now': 'متاح الآن',
    'lease_ending_soon': 'ينتهي الإيجار قريبًا',
    'no_apartments_found': 'لم يتم العثور على وحدات معرض مناسبة',
    'ready': 'جاهز',
    'ends_in_days': 'ينتهي خلال {{count}} يوم',
    'search_unit': 'البحث عن وحدة معرض...',
    'currently_occupied': 'مشغولة حالياً',
    'occupied': 'مشغولة',
    'occupied_status': 'مشغولة',
    'financial_status': 'الحالة المالية',
    'occupancy_physical': 'الإيجار الفعلي',
    'unit_indicators': 'مؤشرات الوحدة',
    'furnished_unit': 'وحدة مجهزة',
    'lease_expired_short': 'إنتهاء العقد',
    'lease_ended_short': 'إنتهاء العقد',
    'expired_label': 'إنتهاء العقد',
    'partial': 'جزئي',
    'scheduled_tenants': 'المستأجرون المجدولون',
    'multiple_leases': 'عقود إيجار متعددة',
    'current_end_date': 'تاريخ الانتهاء الحالي',
    'new_end_date': 'تاريخ الانتهاء الجديد',
    'extend': 'تمديد',
    'transfer': 'نقل',
    'expired': 'منتهي',
    'transfer_apartment': 'نقل وحدة المعرض',
    'current_apartment': 'وحدة المعرض الحالية',
    'select_new_apartment': 'اختر وحدة المعرض الجديدة',
    'new_monthly_rent': 'الإيجار الشهري الجديد',
    'transferring': 'جاري النقل...',
    'failed_to_transfer_tenant': 'فشل نقل المستأجر',
    'tenant_transferred_success': 'تم نقل المستأجر بنجاح',
    'extend_lease': 'تمديد عقد الإيجار',
    'extend_lease_confirm': 'هل أنت متأكد من رغبتك في تمديد عقد الإيجار؟',
    'lease_extended_success': 'تم تمديد عقد الإيجار بنجاح',
    'select_option': 'اختر خيارًا',

    // Sales Module
    'sales': 'المبيعات',
    'sale_list': 'قائمة المبيعات',
    'new_sale': 'بيع جديد',
    'record_new_sale': 'تسجيل بيع جديد',
    'record_new_sale_subtitle': 'إنشاء مشتري وتخصيص معرض وإعداد خطة الدفع',
    'sales_subtitle': 'إدارة مبيعات العقارات — المشترين والمعارض وخطط الدفع',
    'total_sales': 'إجمالي المبيعات',
    'outstanding_balance': 'الرصيد المستحق',
    'buyer': 'المشتري',
    'buyer_information': 'معلومات المشتري',
    'buyer_name': 'الاسم الكامل',
    'buyer_name_placeholder': 'مثال: أحمد الراشد',
    'buyer_phone': 'الهاتف',
    'buyer_language': 'اللغة المفضلة',
    'select_apartment': 'اختر معرض',
    'select_apartment_required': 'اختر معرض *',
    'available_apartments_count': '{{count}} متاحة',
    'no_apartments_available_sale': 'لا توجد معارض متاحة — جميع المعارض لديها ملاك بالفعل.',
    'payment_plan': 'خطة الدفع',
    'full_payment': 'الدفع الكامل',
    'installments_plan': 'أقساط',
    'total_sale_price': 'إجمالي سعر البيع (دولار)',
    'total_sale_price_placeholder': 'مثال: 75000',
    'payment_date_label': 'تاريخ الدفع',
    'first_payment_date': 'تاريخ أول دفعة',
    'num_installments': 'عدد الأقساط',
    'per_installment_hint': '≈ ${{amount}} / قسط • جدول شهري',
    'record_sale': 'تسجيل البيع',
    'sale_recorded_success': 'تم تسجيل البيع بنجاح!',
    'sale_deleted': 'تم حذف البيع',
    'payment_recorded': 'تم تسجيل الدفعة',
    'no_sales_found': 'لم يتم العثور على مبيعات',
    'record_first_sale': 'تسجيل أول عملية بيع',
    'sale_not_found': 'البيع غير موجود',
    'delete_sale_confirm': 'حذف هذا البيع؟ سيؤدي ذلك إلى إزالة العقد وفك ارتباط المعرض.',
    'delete_sale_all_confirm': 'حذف هذه العملية بأكملها؟ لا يمكن التراجع عن هذا.',
    'sale_detail': 'تفاصيل البيع',
    'sale_date': 'تاريخ البيع',
    'financials': 'المالية',
    'collected': 'تم التحصيل',
    'balance': 'الرصيد',
    'payment_progress': 'تقدم الدفع',
    'installments': 'الأقساط',
    'due_date': 'تاريخ الاستحقاق',
    'mark_paid': 'تعليم كمدفوع',
    'confirm_payment': 'تأكيد',
    'payment_date_label2': 'تاريخ الدفع:',
    'all_statuses': 'جميع الحالات',
    'search_sales_placeholder': 'بحث عن مشترٍ، هاتف، معرض...',
    'sale_progress': 'التقدم',
    'sale_balance': 'الرصيد',
    'sale_paid': 'مدفوع',
    'sale_unpaid': 'غير مدفوع',
    'sale_partial': 'جزئي',
    'notes_optional': 'ملاحظات (اختياري)',
    'notes_placeholder': 'أي معلومات إضافية...',
    'failed_to_load_sales': 'فشل تحميل المبيعات',
    'failed_to_delete_sale': 'فشل حذف البيع',
    'failed_to_record_payment': 'فشل تسجيل الدفعة',
    'failed_to_load_sale': 'فشل تحميل البيع',
    'failed_to_create_sale': 'فشل إنشاء البيع',
    'buyer_name_required': 'اسم المشتري مطلوب',
    'valid_phone_required': 'رقم هاتف صحيح مطلوب',
    'apartment_required_sale': 'يرجى اختيار معرض',
    'valid_price_required': 'أدخل سعراً صحيحاً',
    'first_payment_date_required': 'تاريخ أول دفعة مطلوب',
    'valid_installment_amounts_required': 'أدخل مبلغاً صحيحاً لكل قسط',
    'installment_amounts_must_match_total': 'يجب أن يكون مجموع مبالغ الأقساط مساوياً لسعر البيع الإجمالي',
    'edit_installment_amounts': 'تعديل المبالغ يدوياً',
    'total_allocated': 'المجموع الموزَّع',
    'remaining': 'المتبقي',
    'matches_total': 'يطابق السعر الإجمالي',
    'mark_as_paid_now': 'تعليم كمدفوع الآن',
    'mark_as_paid_now_hint': 'سيتم تعليم القسط/الأقساط كمدفوعة فوراً بتاريخ اليوم',
    'per_installment_paid_hint': 'سيُعلَّم القسط الأول كمدفوع؛ والباقية ستُضبط كمعلقة',

    // تقرير الإيرادات
    'rent_revenue': 'إيراد الإيجار',
    'service_revenue': 'إيراد الخدمات',
    'insurance_revenue': 'إيراد التأمين',
    'sale_revenue': 'إيراد المبيعات',

    // عمولة البيع
    'sale_has_commission': 'شركة العقارات تأخذ عمولة على هذا البيع',
    'commission': 'العمولة',
    'commission_percent': '% من السعر',
    'commission_fixed_amount': 'مبلغ ثابت',
    'commission_rate': 'نسبة العمولة',
    'commission_amount': 'مبلغ العمولة',
    'commission_notes': 'ملاحظة العمولة (اختياري)',
    'commission_notes_placeholder': 'مثال: اسم الوكالة / السبب',
    'commission_deducted_label': 'العمولة المخصومة من هذا البيع',
    'net_to_company': 'الصافي للشركة',
    'valid_commission_rate_required': 'يجب أن تكون نسبة العمولة بين 0 و100',
    'valid_commission_amount_required': 'يجب أن يكون مبلغ العمولة رقماً صحيحاً غير سالب',
    'commission_exceeds_price': 'لا يمكن أن يتجاوز مبلغ العمولة السعر الإجمالي للبيع',
    'total_commission_paid': 'العمولة المدفوعة',
    'sale_commission_expense': 'عمولة البيع المدفوعة',
    'sale_commission_expense_hint': 'خصم عمولة الوكالة العقارية على المبيعات المغلقة خلال هذه الفترة — لا تُخصم من إيراد المبيعات أعلاه.',
    'net_revenue_after_commission': 'صافي الإيراد (بعد العمولة)',
    'net_revenue_after_commission_hint': 'إجمالي الإيراد ناقص عمولة البيع المدفوعة. لا يشمل مصاريف أخرى (صيانة، رواتب، إلخ) — غير متتبَّعة في هذا النظام حالياً.',

    'update_complex_desc': 'تحديث التفاصيل الهيكلية لهذا المجمع.',
    'define_complex_desc': 'حدد موقع وسعة مجمعك اللوجستي الجديد.',
    'used_for_mapping_desc': 'يستخدم للخرائط وإنشاء التقارير الرسمية.',
    'how_many_blocks_desc': 'كم عدد الكتل أو الصفوف المميزة التي يمتلكها هذا المجمع؟',
    'm2_free': 'م² متاح',
    'utilization': 'استغلال',
    'overdue_payments': 'مدفوعات متأخرة',
    'all_payments_current': 'جميع المدفوعات جارية',
    'm2_total_area': 'م² إجمالي المساحة',
    'type_small': 'صغير',
    'type_medium': 'متوسط',
    'type_large': 'كبير',
    'type_extra_large': 'كبير جداً',
    'type_cold_storage': 'تخزين مبرد',
    'type_drive-in': 'قيادة للداخل',
    'zone': 'منطقة',
    'units': 'وحدات',
    'front': 'أمامي',
    'back': 'خلفي',
    'side': 'جانبي',
    'back_row': 'الصف الخلفي',
    'front_row': 'الصف الأمامي',
    'wall': 'جدار',

    // ── Service Management ──────────────────────────────────────────
    'service_payments_management': 'إدارة رسوم الخدمات',
    'service_payments_for_building_year': 'رسوم الخدمات لـ {{building}} — {{year}}',
    'back_to_dashboard': 'العودة إلى لوحة التحكم',
    'refresh': 'تحديث',
    'data_refreshed_successfully': 'تم تحديث البيانات بنجاح',
    'failed_to_refresh_data': 'فشل في تحديث البيانات',
    'loading_service_data': 'جارٍ تحميل بيانات الخدمات...',
    'select_building': 'اختر المجمع',
    'no_building_selected': 'لم يتم اختيار مجمع',
    'please_select_building': 'يرجى اختيار مجمع لعرض مدفوعات الخدمات.',
    'no_floors_available': 'لا توجد طوابق متاحة',
    'no_floors_message': 'لا توجد طوابق تحتوي على معارض في هذا المجمع، أو لم يتم إنشاء مدفوعات الخدمات بعد.',
    'failed_to_load_buildings': 'فشل في تحميل المجمعات',
    'failed_to_load_floors': 'فشل في تحميل الطوابق',
    'failed_to_load_floor_data': 'فشل في تحميل بيانات الطابق',
    'failed_to_load_building_floors': 'فشل في تحميل طوابق المجمع',
    'no_apartments_on_floor': 'لا توجد معارض في هذا الطابق.',
    'no_matching_apartments': 'لا توجد معارض تطابق بحثك.',
    'no_search_results': 'لا توجد نتائج تطابق بحثك.',
    'filter_by_status': 'تصفية حسب الحالة',
    'search_apartments_tenants': 'بحث في الوحدات، الملاك، المستأجرين...',
    'view_statistics': 'عرض الإحصائيات',
    'summary': 'ملخص',
    'zone_showroom_count': 'المنطقة {{zone}} — {{count}} وحدة',
    'generate_payment': 'إنشاء دفعة',
    'generate_payment_for': 'إنشاء دفعة للمعرض {{number}}',
    'payment_amount': 'مبلغ الدفعة',
    'enter_amount': 'أدخل المبلغ',
    'invalid_amount': 'يرجى إدخال مبلغ صحيح أكبر من 0',
    'mark_as_paid_immediately': 'تعليم كمدفوع فوراً',
    'payment_notes': 'ملاحظات الدفعة',
    'required_fields': 'الحقول المطلوبة',
    'payment_generated_successfully': 'تم إنشاء الدفعة بنجاح',
    'failed_to_generate_payment': 'فشل في إنشاء الدفعة',
    'failed_to_update_payment': 'فشل في تحديث الدفعة',
    'payment_marked_as_paid': 'تم تعليم الدفعة كمدفوعة',
    'payment_marked_as_unpaid': 'تم تعليم الدفعة كغير مدفوعة',
    'marked_as_paid_via_service_management': 'تم التعليم كمدفوع عبر إدارة الخدمات',
    'marked_as_unpaid_via_service_management': 'تم التعليم كغير مدفوع عبر إدارة الخدمات',
    'payment_details': 'تفاصيل الدفعة',
    'payment_due': 'الدفعة المستحقة',
    'paid_on': 'تم الدفع بتاريخ {{date}}',
    'rate': 'السعر',
    'unpaid': 'غير مدفوع',

    // ── Building View ───────────────────────────────────────────────
    'edit_complex': 'تعديل المجمع',
    'attention_required': 'تنبيه مطلوب',
    'overdue_payment': 'دفعة متأخرة',
    'available': 'متاح',
    'vacant_available': 'شاغر / متاح',
    'corner': 'ركنية',

    // ── Owner Form / Sale Form ──────────────────────────────────────
    'failed_to_load_data': 'فشل في تحميل البيانات',
    'failed_to_save_owner': 'فشل في حفظ بيانات المالك',
    'lives_on_property': 'يسكن في العقار',
    'monthly_service_fee_applies': 'تسري رسوم الخدمة الشهرية',
    'works_at_showroom': 'المشتري يعمل في هذا المعرض',
    'change': 'تغيير',

    // ── 2FA / OTP ───────────────────────────────────────────────────
    'otp_security_verification': 'التحقق الأمني',
    'otp_enter_code_whatsapp': 'يرجى إدخال رمز التحقق المرسل إلى واتساب الخاص بك.',
    'otp_verification_code': 'رمز التحقق',
    'otp_check_whatsapp': 'تحقق من واتساب للحصول على الرمز',
    'otp_invalid_code': 'يرجى إدخال رمز تحقق صحيح',
    'otp_resent': 'تم إعادة إرسال رمز التحقق إلى واتساب الخاص بك',
    'otp_verify_code': 'تحقق من الرمز',
    'otp_verifying': 'جارٍ التحقق...',
    'otp_resend_code': 'إعادة إرسال الرمز',
    'otp_back_to_login': 'العودة إلى تسجيل الدخول',
  }
}